/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} z {b}',
  about: 'Informacje',
  aboutThisItem: 'O tym elemencie',
  accessApiKeyManager: 'Dostęp do menedżera klucza API tego środowiska.',
  accessControls: 'Kontrola Dostępu',
  accessControlsCopiedText: 'Ustawienia kontroli dostępu są aktualizowane natychmiastowo. Uprawnienia zabezpieczeń multimediów zostaną zaktualizowane po upływie kilku minut.',
  accessControlsCopiedTitle: 'Z powodzeniem skopiowano ustawienia kontroli dostępu',
  accessControlsCopyConfirmation: 'Spowoduje to usunięcie wszystkich istniejących ustawień kontroli dostępu z {to} i zastąpienie ich ustawieniami kontroli dostępu z {from}. Tej operacji nie można cofnąć.',
  accessControlsDescription: 'Kontrola dostępu określa, kto może przeglądać media w zależności od wybranych kategorii Organizacje oraz Kategorie Mediów.',
  accessControlsHelpText: 'Zarządzaj kontrolą dostępu dla tej organizacji. Użytkownicy mogą uzyskać dostęp do wymienionych mediów tylko wówczas, gdy mają uprawnienia do przeglądania kategorii mediów, do których należą poszczególne media. Zastosowanie wielu mediów w organizacji może zająć trochę czasu. Poczekaj, aż zmiany zaczną obowiązywać, i użyj przycisku odświeżania.',
  accessControlsIndeterminance: 'Uwaga: Organizacje nadrzędne zawsze mają prawa dostępu do treści każdej z organizacji podrzędnych.',
  accessControlsRefreshWarning: 'Masz niezapisane zmiany. Odświeżenie spowoduje ich usunięcie. Chcesz kontynuować?',
  accessControlsSaveSuccess: 'Zapisano ustawienia kontroli dostępu.',
  accessControlsTitleSection: 'Gdy kontrole dostępu zostaną zastosowane do tej organizacji, zostaną one również automatycznie delegowane do następujących organizacji poprzez dziedziczenie wsteczne:',
  accessControlsTooltip: 'Organizacje mają również dostęp do treści, do których mają dostęp ich organizacje podrzędne. Poniższa siatka nie obejmuje treści, do których ta organizacja ma dostęp poprzez domniemane delegowanie w górę lub dziedziczenie wsteczne.',
  account: 'Konto',
  accountErrorMessage: 'Komunikat o błędzie konta',
  accountErrorMessageWarning: 'Pole accountErrorMessage w bazie danych dla tego środowiska zostanie ustawione na „Brak uprawnień”.',
  action: 'Czynność | Czynności',
  actionDelete: 'usuń',
  actionLoad: 'załaduj',
  actionPaste: 'Wklej',
  actionRun: 'wykonaj',
  actionSave: 'Zapisz',
  actionUndoWarning: 'Tej operacji nie można cofnąć.',
  actionUpload: 'prześlij',
  actualSize: 'Faktyczny Rozmiar',
  add: 'Dodaj',
  addABookText: 'Dodaj katalog',
  addABookToStart: 'Aby rozpocząć, {addABookText}.',
  addAForm: 'Dodaj Formularz, aby rozpocząć',
  addAFormOnly: 'Dodaj formularz',
  addAMedia: 'Dodaj multimedia',
  addAPIKey: 'Dodaj Klucz API',
  addAPartCollection: 'Dodaj {partCollection}, aby rozpocząć.',
  addAPrintSettingText: 'Dodaj Ustawienia Drukowania',
  addAPrintSettingToStart: 'Aby rozpocząć, {addAPrintSettingText}.',
  addASharedCart: 'Dodaj koszyk współdzielony',
  addATag: 'Dodaj etykietę',
  addATemplate: 'Dodaj szablon',
  addAllPartsCart: 'Dodaj wszystkie części do koszyka',
  addAnOrderQuoteEmailFormat: 'Dodaj format wiadomości e-mail z zamówieniem/zapytaniem',
  addBooks: 'Dodaj Katalogi',
  addBrowseFlow: 'Dodaj Kierunek Przeglądania',
  addChapter: 'Dodaj Rozdział',
  addChildBrowseFlow: 'Dodaj Podrzędny Kierunek Przeglądania',
  addComment: 'Dodaj komentarz',
  addExistingPart: 'Dodaj Istniejącą Część',
  addGroupsToUsers: 'Dodaj grupy {groups} do użytkowników: {users}',
  addItem: 'Dodaj {item}',
  addMedia: 'Dodaj Multimedia',
  addPages: 'Dodaj Strony',
  addPart: 'Dodaj Część',
  addReports: 'Dodaj Raporty',
  addRootBrowseFlow: 'Dodaj Główny Kierunek Przeglądania',
  addRow: 'Dodaj wiersz',
  addTemplates: 'Dodaj szablony',
  addToCartMessage: 'Pomyślnie dodano pozycję {partNumber}',
  addToUserGroup: 'Dodaj do Grup',
  addWidgetKey: 'Dodaj klucz widżetu',
  addedOn: 'Dodano',
  additionalInformation: 'Dodatkowa Informacja',
  additionalNotification: 'Dodatkowe Powiadomienie',
  additionalPartNumberDescription: 'Użyj jako dodatkowego pola numeru części',
  address: 'Adres | Adresy',
  addressInUse: 'Adres jest obecnie ustawiony jako adres domyślny i nie może zostać usunięty',
  addressInUseSubtitle: 'Aby usunąć ten adres, musisz najpierw anulować ustawienie tego adresu jako domyślnego.',
  addressLine: 'Linia adresu {number}',
  addressState: {
    confirmationMessage: 'Następujące adresy nie zostały zweryfikowane.',
    confirmationTitle: 'Czy na pewno chcesz kontynuować z niezweryfikowanymi adresami?',
    disabledVerification: 'Weryfikacja adresu zostanie wyłączona dla pola przy składaniu zamówienia/oferty.',
    enteredAddress: 'Wprowadzony adres',
    failedToFetchSuggestions: 'Nie udało się pobrać sugestii adresu.',
    failedToLoadDetails: 'Nie udało się załadować danych adresowych.',
    incomplete: 'Niekompletny adres',
    missingSubpremise: 'Brakująca przesłanka podrzędna',
    noSuggestions: 'Nie znaleziono żadnych sugestii. Edytuj adres dla sugestii.',
    selectAddress: '(wybierz jedną opcję)',
    subpremiseMessage: 'Wygląda na to, że jest to adres budynku mieszkalnego lub biurowego. Dodaj numer lokalu, mieszkania lub apartamentu, aby uzupełnić adres.',
    suggested: 'Sugerowane adresy',
    unverified: 'Niezweryfikowany adres',
    unverifiedHelpText: 'Wybierz inny zapisany adres, edytuj ten adres lub dodaj nowy.',
    unverifiedMessage: 'Nie możemy zweryfikować tego adresu pod kątem dostawy.',
    verified: 'Zweryfikowany adres'
  },
  admin: 'Administrator',
  adminCenter: 'Centrum Administracyjne',
  adminCenterBanner: {
    bodyLabel: 'Treść baneru',
    enableLabel: 'Włącz baner administratora',
    headerGreenOption: 'Zielony',
    headerLabel: 'Nagłówek baneru',
    headerRedOption: 'Czerwony',
    headerYellowOption: 'Żółty',
    title: 'Baner centrum administracyjnego',
    typeLabel: 'Typ baneru'
  },
  adminCenterMessage: 'Centrum administracyjne dla zawartości, użytkowników, ustawień biblioteki, raportowania i eksportu',
  adminMessage: 'Funkcje są dodawane w miarę ich udostępniania',
  administration: 'Administracja',
  advancedFilters: 'Filtry zaawansowane',
  affectedBookMedia: 'Elementy multimedialne ksiąg, które zostaną zaktualizowane: {count}.',
  affectedProductPages: '{count} str. produktów do zaktualizowania.',
  affectedTemplateMedia: 'Szablony ksiąg, które zostaną zaktualizowane: {count}.',
  after: 'Po',
  aggregatedFromChildren: 'Zgromadzone z Podmiotów Podrzędnych',
  aiAlgorithm: 'Skaner SI',
  algorithm: 'Algorytm',
  alignHorizontal: 'Wyrównaj w Poziomie',
  alignVertical: 'Wyrównaj w Pionie',
  all: 'Wszystko',
  allLibraryPages: 'Wszystkie strony biblioteki',
  allPagesAndBooks: 'Wszystkie strony i księgi',
  allUsersDisabled: 'Wszyscy użytkownicy należący do środowiska zostaną zablokowani.',
  alphanumeric: 'Alfanumeryczne',
  analyticsJSON: 'Analityka JSON',
  andCountMore: 'i więcej: {count}…',
  announcement: 'Ogłoszenie | Ogłoszenia',
  any: 'Dowolne',
  apiAuthHeader: 'Nagłówek Autoryzacji API',
  apiKey: 'Klucz API | Klucze API',
  apiKeyAdmin: 'Administrator Klucza API',
  apiKeyCopied: 'Skopiowano wartość Nagłówka Autoryzacji API do Schowka',
  apiKeyDeleteMsg: 'Usunięcie tego Klucza API wyłączy jego użycie przez integracje',
  apiKeyDeleteTitle: 'Czy na pewno chcesz usunąć ten Klucz API?',
  apiKeyDeleted: 'Klucz API usunięty',
  apiKeyDeletedError: 'Błąd usuwania Klucza API',
  apiKeyInstructions: 'Klucz zostanie wygenerowany po Zapisaniu',
  apiKeyManager: 'Menedżer Klucza API',
  apiKeyNameEmpty: 'Nazwa nie może być pusta',
  apiKeyRegenError: 'Błąd podczas ponownego generowania Klucza API',
  apiKeyRegenMsg: 'Ponowne wygenerowanie tego Klucza API może wyłączyć istniejące integracje',
  apiKeyRegenTitle: 'Czy na pewno chcesz ponownie wygenerować ten Klucz API?',
  apiKeySaved: 'Klucz API Zapisany',
  apiKeyType: 'Typ klucza API',
  appliesTo: 'Dotyczy',
  appliesToEmpty: 'Wymagany jest przynajmniej jeden typ jednostki',
  appliesToPopulated: 'Zdecyduj, do jakich jednostek można stosować znacznik',
  apply: 'Zastosuj',
  applyItem: 'Zastosuj obiekt {item}',
  applyToChildItems: 'Zastosuj do elementu podrzędnego {item}',
  applyToPartOnly: 'Zastosuj tylko do tej części',
  april: 'Kwiecień',
  areYouSure: 'Czy na pewno chcesz usunąć {item}?',
  areYouSureCopy: 'Czy na pewno chcesz skopiować {item}?',
  areYouSureYouWantToDisableTheTenant: 'Czy na pewno chcesz zablokować środowisko?',
  area: 'Obszar',
  assembly: 'Zespół | Zespoły',
  assemblyConfirmationTitle: 'Czy na pewno chcesz zakończyć tworzenie zespołu?',
  assemblyCreatorHelpText1: 'Ta funkcja pozwala na wstawienie wybranej strony do katalogów wszędzie tam, gdzie znajduje się ta część {partName}, co automatycznie łączy część i wybraną stronę łączem hotpoint. Opcjonalnie można ograniczyć wstawianie łączy tylko do wybranych katalogów.',
  assemblyCreatorHelpText2: 'Wybrana strona jest wstawiana raz na katalog po pierwszym wystąpieniu części {partName}.',
  assemblyCreatorSuccessSubtitle: 'Linki Hotpoint i zmiany w spisie treści katalogów zostaną wprowadzone natychmiast. Wyniki wyszukiwania zostaną odzwierciedlone po zakończeniu indeksowania.',
  assemblyCreatorSuccessTitle: 'Przesłano zadanie Utwórz montaż',
  assemblyStepOne: 'Krok 1: Wybierz stronę do wstawienia',
  assemblyStepTwo: 'Krok 2: Wybierz katalogi, do których chcesz wstawić stronę',
  asset: 'Zasób | Zasoby',
  assetsNotFound: 'Nie Znaleziono: {type}',
  assignBrowseFlow: 'Przypisz Kierunek Przeglądania',
  assignMedia: 'Przypisz media',
  assignMediaToItem: 'Przypisz media do tej strony {item}.',
  assignedOrganizations: 'Przypisane Organizacje',
  associateProductPage: 'Powiąż istniejące strony produktu',
  associateProductPageDescription: 'Powiąż strony produktów z tymi multimediami.',
  associateProductPageTip: 'Wskazówka: Kliknięcie przycisku „Utwórz nową stronę produktu” spowoduje otwarcie karty umożliwiającej dodanie nowej strony produktu, jeśli produkt, który chcesz powiązać, jeszcze nie istnieje. Nadal będzie trzeba wrócić do tej strony, aby powiązać nową stronę produktu po jej utworzeniu.',
  associateProducts: 'Powiąż produkty',
  atLeastFiveError: 'Prosimy wybrać wartość, która nie jest niższa niż 5.',
  attachRelatedPDFs: 'Załącz powiązane strony części w formacie PDF',
  attachment: 'Załącznik | Załączniki',
  attachmentEditorDescription: 'Załącz obrazy, klipy wideo oraz dokumenty bezpośrednio do tej jednostki. Pamiętaj, że nie będą się one znajdować w zakładce „Powiązane”.',
  attachmentEditorDescriptionPP: 'Załącz obrazy, klipy wideo oraz dokumenty bezpośrednio do tej jednostki.',
  attachmentFileUploadSizeError: 'Rozmiar pliku przekracza limit 50 MB',
  attachmentView: 'Zobacz Załączniki',
  attributions: 'Atrybucje',
  august: 'Sierpień',
  autoHideEmptyCards: 'Automatycznie ukrywaj puste karty',
  autoHotpoint: 'Automatyczne Punkty Interaktywne',
  autoPopulate: 'Automatycznie Wypełnij',
  automaticZoom: 'Powiększenie Automatyczne',
  availability: 'Dostępność',
  back: 'Wstecz',
  backCover: 'Okładka Tylna',
  backStitch: 'Szycie Grzbietu',
  backToLibrary: 'Powrót do Biblioteki',
  backToSearch: 'Powrót do Wyszukiwania',
  badCredentials: 'Błędne Dane Uwierzytelniające',
  badDefaultValueMessage: 'Domyślna wartość musi mieścić się w przedziale od {min} do {max} znaków.',
  bahasaDescription: 'Opis Indonezyjski',
  bahasaName: 'Nazwa Indonezyjska',
  banner: 'Baner',
  banners: 'Banery',
  barColor: 'Kolor paska',
  before: 'Przed',
  beginTypingToFindAnything: 'Zacznij wpisywanie, aby rozpocząć szukanie',
  beta: 'Beta',
  betaAccessKeys: 'Klucze dostępu do wersji beta',
  betaReleaseVideo: 'Wideo w Wersji Beta',
  betaResources: 'Zasoby Beta',
  blobFinder: 'Wyszukiwarka BLOB',
  body: 'Treść',
  bom: 'Lista Materiałowa',
  bomDefaultSupplier: 'Domyślny dostawca listy materiałowej',
  bomExportSuccess: 'Pomyślnie wyeksportowano listę materiałową',
  bomItem: 'Pozycja na Liście Materiałowej',
  bomItems: 'Pozycje listy materiałowej',
  bomLayout: 'Układ Zestawienia Materiałowego',
  bomListOptions: 'Lista Opcji Zestawienia Materiałów',
  bomListSettings: 'Ustawienia Listy Zestawienia Materiałów',
  book: 'Katalog | Katalogi',
  bookInserts: 'Wkładki do Katalogów',
  bookLabel: 'Katalog | Katalogi',
  bookPrintingDisable: 'Wyłącz Wydruk Katalogów',
  booksAndPagesDisplay: 'Wyświetlanie Katalogów i Stron',
  boost: 'Przyspieszenie Wyszukiwania',
  boostDescription: 'Dodaj wartość powyżej 1,5, aby zwiększyć istotność tego znacznika w wynikach wyszukiwania ponad numery części, identyfikatory mediów oraz nazwy',
  boostRangeInvalid: 'Wzmocnienie musi wynosić między 0,5 a 100,0',
  border: 'Ramka',
  both: 'Oba',
  bottom: 'Dół',
  branding: 'Znakowanie',
  browse: 'Przeglądaj',
  browseComputer: 'Przeglądaj Komputer',
  browseFlow: 'Kierunek Przeglądania | Kierunki Przeglądania',
  browseFlowAssigned: 'Przypisany Kierunek Przeglądania',
  browseFlowCopyMessage: 'Wprowadź unikalną nazwę nowego Kierunku Przeglądania.',
  browseFlowDeleteMessage: 'Usunięcie kierunku przeglądania powoduje usunięcie nie tylko kierunku przeglądania, ale wszystkich jego podrzędnych przepływów przeglądania.',
  browseFlowDeleted: 'Usunięto przepływ przeglądania',
  browseFlowEmptyState: 'Nie zdefiniowano żadnych Kierunków Przeglądania. Aby rozpocząć, {new}.',
  browseFlowHierarchy: 'Hierarchia kierunku przeglądania',
  browseFlowMediaCategoryProductPageHelpText: 'Usuń aktualnie dodane kryteria wyszukiwania „Typ: Strona produktu”, aby zastosować zmiany',
  browseFlowMoveToRoot: 'Upuść węzeł tutaj, aby utworzyć element podrzędny pierwszego rzędu',
  browseFlowNoAssignedOrgs: 'Brak przypisanych organizacji',
  browseFlowNoExistingCriteria: 'Nie definiowano kryteriów dla tego kierunku przeglądania.  Korzystaj z elementów sterowania powyżej, aby wybrać kryteria wyszukiwania.',
  browseFlowNoExistingCriteriaBelow: 'Nie zdefiniowano kryteriów dla tego kierunku przeglądania.  Korzystaj z elementów sterowania poniżej, aby wybrać kryteria wyszukiwania.',
  browseFlowSaveFailed: 'Nie można zaktualizować Kierunków Przeglądania',
  browseFlowSaved: 'Zapisano Kierunek Przeglądania',
  browseFlowSelectionRequired: 'Wymagany jest wybór kierunku przeglądania.',
  browseFlowSetDefaultSuccess: 'Ustawiono domyślny Kierunek Przeglądania',
  browseFlowThumbnailDeleteFailTitle: 'Usunięcie Miniatury Nie Powiodło Się',
  browseFlowThumbnailDeleteSuccessTitle: 'Pomyślne Usunięcie Miniatury',
  browseFlowThumbnailUploadFailTitle: 'Przekazanie Miniatury Nie Powiodło Się',
  browseFlowThumbnailUploadSuccessTitle: 'Pomyślne Przekazanie Miniatury',
  browseFlowTooManyOrgs: 'Zbyt wiele organizacji korzysta z bieżącego edytora kierunku przeglądania. Skontaktuj się z przedstawicielem Pomocy Technicznej Documoto pod adresem {email} w celu uzyskania pomocy w zakresie kierunków przeglądania Documoto.',
  browserDeprecation: {
    text: 'W związku z wycofywaniem przez firmę Microsoft wsparcia dla przeglądarki Internet Explorer (wszystkie wersje) i związanymi z tym obawami dotyczącymi bezpieczeństwa, nie będziemy już wspierać dostępu użytkowników do tej witryny za pośrednictwem przeglądarki Internet Explorer (wszystkie wersje) po 30 września 2021 r.',
    title: 'Komunikat Przestarzałej Przeglądarki'
  },
  browserPartiallySupport: 'W przeglądarce mogą być widoczne różnice estetyczne i inne zmiany.',
  buildHotpointLinks: 'Buduj Łącza Hotpoint',
  buildHotpointLinksInfo: 'Ta akcja najpierw spowoduje usunięcie wszystkich istniejących łączy hotpoint ze stron katalogu, a następnie utworzy nowe łącza hotpoint pomiędzy częściami i wszystkimi dopasowanymi stronami montażu.',
  buildHotpointLinksTitle: 'Czy chcesz wprowadzić łącza hotpoint w tym katalogu?',
  bulkApplyAllOrgs: 'Zbiorcze zastosowanie do wszystkich organizacji',
  bulkApplyAllOrgsModalMsg: 'Czy na pewno chcesz zastosować dostęp do tej zawartości dla wszystkich organizacji? Kliknięcie przycisku „Potwierdź” spowoduje natychmiastowe zastosowanie dostępu do wszystkich organizacji, a zmiany kontroli dostępu zostaną zapisane.',
  bulkExportConfirm: 'Czy chcesz wyeksportować {n} {unit}?',
  bulkExportLimit: 'Maksymalna liczba katalogów na czynność eksportu: {limit}',
  bulkImport: 'Import zbiorczy',
  bulkIndexingLane: 'Pas indeksowania zbiorczego',
  bulkInsert: 'Wprowadzanie Zbiorcze',
  bulkPageInsertJob: 'Zbiorcze Wstawianie Stron',
  bulkRemoveAllOrgs: 'Usuń zbiorczo ze wszystkich organizacji',
  bulkRemoveAllOrgsModalMsg: 'Czy na pewno chcesz usunąć dostęp do tej zawartości we wszystkich organizacjach? Kliknięcie przycisku „Potwierdź” spowoduje natychmiastowe usunięcie dostępu we wszystkich organizacjach, a zmiany kontroli dostępu zostaną zapisane.',
  business: 'Business',
  button: 'Przycisk',
  cameraSettings: 'Ustawienia kamery',
  cancel: 'Anuluj',
  cancelAssemblyCreatorSubtitle: 'Zadanie Utwórz montaż nie będzie przetwarzane.',
  cancelAssemblyCreatorTitle: 'Usunąć zadanie Utwórz montaż?',
  canceled: 'Anulowano',
  cannotExceed100: 'Nie może przekraczać 100%',
  cannyWidgetLoadFailure: 'Nie udało się załadować forum opinii',
  cart: 'Koszyk | Koszyki',
  cartBehaviorDisabled: 'Wyłącz Zachętę do Dodawania do Koszyka',
  cartBehaviorEnabled: 'Włącz Zachętę do Dodawania do Koszyka',
  cartBehaviorLabel: 'Zachowanie Ilościowe Dodawania do Koszyka',
  cartColumn: 'Kolumna Koszyka | Kolumny Koszyków',
  cartColumn1: '1. Kolumna Cen w Koszyku',
  cartColumn2: '2. Kolumna Cen w Koszyku',
  cartColumn3: '3. Kolumna Cen w Koszyku',
  cartColumnPartLocationContent1: 'Włączenie tej funkcji będzie miało następujące skutki:',
  cartColumnPartLocationContent2: 'Unikalność wiersza części w koszyku będzie również oparta na jego lokalizacji w obrębie fragmentu treści, jeśli ma to zastosowanie.',
  cartColumnPartLocationContent3: 'To ustawienie nie może być wyłączone na poziomie organizacji i będzie miało zastosowanie do wszystkich użytkowników.',
  cartColumnPartLocationContent4: 'To ustawienie nie powinno być włączane bez wcześniejszego kontaktu z Menedżerem ds. Sukcesu Klienta w Documoto, jeśli posiadasz integrację Submit Cart.',
  cartColumnPartLocationOption: 'Włącz Dane Lokalizowania Części w Koszyku',
  cartColumnPartLocationTitle: 'Czy na pewno chcesz włączyć Dane Lokalizowania Części w Koszyku?',
  cartDisable: 'Wyłącz Koszyk',
  cartEmailFailed: 'Nie udało się wysłać e-maila dotyczącego koszyka',
  cartEmailSent: 'E-mail dotyczący koszyka wysłany',
  cartEnable: 'Włącz Koszyk',
  cartErpMessage: 'Pomyślnie wysłano do systemu Erp',
  cartImportError: 'Błąd podczas importowania koszyka',
  cartLoadedWithItemsRemoved: 'Usunięto pozycje w liczbie {count}, ponieważ nie masz aktualnie uprawnień do ich zamawiania',
  cartSaveEnable: 'Włącz Zapisywanie Koszyka',
  cartSharedAddEdit: 'Dodaj / Edytuj Koszyki Współdzielone',
  cartUpdated: 'Zaktualizowano Koszyk',
  cartUpdatedAndRemovedCount: 'Koszyk Zaktualizowany; Usunięto części niemożliwe do zamówienia w liczbie {count}',
  category: 'Kategoria | Kategorie',
  categoryCreated: 'Utworzono Kategorię',
  categoryNotFoundError: '403: Nie można znaleźć kategorii jednostki',
  categoryUpdated: 'Zaktualizowano Kategorię',
  centimeter: 'Centymetr | Centymetry',
  changeNotification: 'Zawiadomienie o Zmianie',
  changeScope: 'Wystąpi wpływ na: {n} {type}',
  changeUserOrganization: 'Zmień Organizację',
  chapter: 'Rozdział | Rozdziały',
  chapterHeader: 'Nagłówek Rozdziału',
  chaptersOnly: 'Tylko Rozdziały',
  charLimitHelpText: 'Wpisz od {min} do {max} znaków',
  chineseDescription: 'Opis Chiński',
  chineseName: 'Nazwa Chińska',
  circle: 'Okrąg',
  city: 'Miasto',
  className: 'Nazwa klasy',
  classicAdminMessage: 'Spowoduje to powrót do Flex w celu skorzystania z modułów administratora.',
  classicAdmins: 'Administratorzy Klasyczni',
  classicExporter: 'Eksporter Klasyczny',
  classicExporterMessage: 'Starszy moduł eksportowania na bazie Flash',
  classicOrganizationAdmin: 'Klasyczny Administrator Organizacji',
  classicOrganizationAdminMessage: 'Starszy moduł administracji na bazie Flash do zarządzania organizacjami i użytkownikami',
  classicPublisher: 'Klasyczny Moduł Publikacji',
  classicPublisherMessage: 'Starszy moduł publikacji na bazie Flash do zmiany ustawień tworzenia treści oraz drukowania',
  classicReporting: 'Klasyczne Raportowanie',
  classicReportingMessage: 'Starszy moduł raportowania na bazie Flash',
  classicTenantAdmin: 'Klasyczny Moduł Administracji Dzierżawy',
  classicTenantAdminMessage: 'Starszy moduł administracji na bazie Flash do zmiany ustawień dzierżawy',
  clear: 'Wyczyść',
  clearFilters: 'Wyczyść Filtry',
  clearHotpoints: 'Wyczyść punkty Hotpoints',
  clearItemNumber: 'Usuń numer pozycji',
  clearItemNumberMessage: 'Usunięcie pozycji spowoduje usunięcie następujących danych:',
  clearItemNumberTitle: 'Czy chcesz usunąć numer pozycji?',
  clearSearch: 'Wyczyść Pole Wyszukiwania',
  clickAction: 'Kliknij przycisk Działanie',
  clickHereToUpload: 'Upuść plik lub kliknij, aby przesłać obiekt zastępczy.',
  clickMagnifyingGlass: 'Kliknij lupkę, aby przejść bezpośrednio do wyszukiwania zaawansowanego.',
  clickOkToContinue: 'Kliknij "OK", aby kontynuować.',
  clickToDownload: 'Kliknij, aby Pobrać',
  clickToEnlarge: 'Kliknij, aby powiększyć',
  clickToOpen: 'Kliknij, aby Otworzyć',
  clipboard: 'Schowek',
  clipboardAccessError: 'Dostosuj ustawienia swojej przeglądarki, aby zezwolić na dostęp do Schowka',
  close: 'Zamknij',
  closed: 'Zamknięto',
  collapseAll: 'Zwiń Wszystko',
  color: 'Kolor | Kolory',
  column: 'Kolumna | Kolumny',
  columnItemType: {
    customText: 'Tekst Własny',
    documentTitle: 'Tytuł Dokumentu',
    horizontalLine: 'Linia Pozioma',
    pageName: 'Nazwa Strony',
    pageNumber: 'Numer Strony',
    printDate: 'Data Wydruku',
    tenantName: 'Nazwa Dzierżawcy',
    userName: 'Nazwa Użytkownika'
  },
  columnMapping: 'Mapowanie kolumny',
  columnName: 'Nazwa Kolumny',
  combinedPage: 'Strona Połączona',
  combinedPageMessage: 'Diagram na górze, lista części na dole',
  comingSoon: 'Wkrótce',
  commaDelimited: 'Oddzielone przecinkiem',
  comment: 'Komentarz | Komentarze',
  commentAdded: 'Dodano komentarz',
  commentCannotBeEmpty: 'Pole Komentarz nie może być puste',
  commentDeleted: 'Usunięto komentarz',
  commentEdit: 'Dodaj / Edytuj Komentarze',
  commentEditAll: 'Edytuj Wszystkie Komentarze',
  commentUpdated: 'Komentarz zaktualizowany',
  commentView: 'Zobacz Komentarze',
  commerceSystem: 'System Handlowy',
  completed: 'Ukończono',
  configuration: 'Konfiguracja | Konfiguracje',
  confirm: 'Zatwierdź',
  confirmBrowseFlowApplyToChildren: 'Czy chcesz zastosować to kierunek przeglądania do organizacji podrzędnych?',
  confirmBrowseFlowOverrideToChildren: 'Spowoduje to usunięcie nadpisanych kierunków przeglądania w organizacjach podrzędnych.',
  confirmPrintSettingsApplyToChildren: 'Czy chcesz zastosować to ustawienie drukowania do organizacji podrzędnych?',
  confirmPrintSettingsOverrideToChildren: 'Spowoduje to usunięcie zmodyfikowanych ustawień wydruku w organizacjach podrzędnych.',
  contains: 'Zawiera',
  containsHeaderRow: 'Zawiera Wiersz Nagłówka',
  content: 'Treść | Treści',
  contentAccessControls: '{content} – Kontrola Dostępu',
  contentEntity: 'Jednostka treści | Jednostki Treści',
  contentNotFound: 'Nie znaleziono treści',
  contentUpdatedQueueJob: 'Zaktualizowana Kolejka Treści',
  contentViewerMoreInfo: 'Więcej informacji',
  contourShape: 'Kształt konturu',
  convertEntity: 'Konwertuj {entity}',
  convertToEntity: 'Konwertuj do {entity}',
  copiedPartNumber: 'Skopiowany numer części {partNumber}',
  copy: 'Kopiuj',
  copyAccessControls: 'Kopiuj Ustawienia Kontroli Dostępu',
  copyAccessControlsWarning: 'Spowoduje to skopiowanie wszystkich przypisanych ustawień kontroli dostępu z wybranej Organizacji do bieżącej Organizacji.',
  copyAndRetain: 'Kopiuj i Zachowaj do Użytku Integracji',
  copyAndRetainWidget: 'Kopiuj i zachowaj; to jedyny raz, gdy wartość autoryzacji widżetu będzie widoczna w aplikacji',
  copyAtoB: 'Kopiuj {a} do {b}',
  copyBranches: 'Skopiuj gałęzie',
  copyBranchesMessage: 'Skopiuj wybrane gałęzie ze źródłowego kierunku przeglądania do docelowego.',
  copyContent: 'Kopiuj {type}? {name}',
  copyItem: 'Kopiuj {item}',
  copyItemQuestion: 'Skopiować pozycję {item}?',
  copyMeMessage: 'Prześlij kopię tej wiadomości do mnie',
  copyPartNumberToClipboard: 'Skopiuj {label} do schowka',
  copyProduct: 'Skopiuj produkt',
  copyTo: 'Kopiuj do {target}',
  copyingItem: 'Kopiowanie {item}',
  copyrightMessage: '© 2010–{year} Documoto Inc. Wszelkie prawa zastrzeżone.',
  count: 'Liczba',
  country: 'Kraj | Kraje',
  coverAmpStitchPages: 'Połącz Strony i Dołącz Okładkę',
  coverPages: 'Strony Okładki',
  createAssembly: 'Utwórz Zespół',
  createNewProductPage: 'Utwórz stronę nowego produktu',
  created: 'Utworzono',
  createdBy: 'Utworzone przez: {name}',
  createdDate: 'Utworzono datę',
  createdOn: 'Utworzono dn.',
  currentPassword: 'Bieżące Hasło',
  custom: 'Niestandardowe',
  czechDescription: 'Opis Czeski',
  czechName: 'Nazwa Czeska',
  dashboard: 'Panel sterowania | Panele sterowania',
  dashboardLibrary: 'Biblioteka Pulpitu',
  dataInsights: 'Wgląd w Dane',
  dataInsightsInfoMessage: 'Raportowanie i Centrum Pulpitu do wglądu w treść, użytkowników i biblioteki.',
  dataMapping: 'Mapowanie Danych / Przykładowe Dane (maksymalnie 10 wierszy)',
  dataOptions: 'Opcje danych',
  date: 'Data',
  dateModified: 'Data Modyfikacji',
  debugPageBuilderPLZ: 'Debuguj Kreatora Stron PLZ',
  december: 'Grudzień',
  decreaseHotpoint: 'Zmniejsz Wartość Punktu Interaktywnego',
  'default': 'Domyślne',
  defaultAddress: 'Domyślny Adres',
  defaultBrowseFlow: 'Domyślny Kierunek Przeglądania',
  defaultCurrencyCode: 'Domyślny Kod Waluty',
  defaultCurrencySymbolOn: 'Domyślny symbol waluty włączony',
  defaultEmailRecipient: 'Domyślny Odbiorca Wiadomości E-mail | Domyślni Odbiorcy Wiadomości E-mail',
  defaultImage: 'Domyślny Obraz | Domyślne Obrazy',
  defaultImagesManager: 'Menedżer Obrazów Domyślnych',
  defaultItemImage: 'Obraz Domyślny {item}',
  defaultPartsListLayout: 'Domyślny Układ Listy Części',
  defaultPartsListLayoutHelp: 'Domyślny układ listy części po lewej lub poniżej ilustracji',
  defaultSearchMode: 'Domyślny Tryb Wyszukiwania',
  defaultSearchModeHelp: 'Domyślna globalna metoda wyszukiwania \'zawiera\' lub \'dokładnie\'',
  defaultSortMode: 'Domyślny Tryb Sortowania',
  defaultSupplier: 'Dostawca Domyślny',
  defaultTocStateOpen: 'Domyślny Stan Spisu Treści Otwarty',
  defaultTocStateOpenHelp: 'Określa, czy Spis Treści powinien otwierać się automatycznie podczas przeglądania katalogu',
  defaultUom: 'Domyślna Jednostka Miary',
  defaultValue: 'Domyślna Wartość',
  defaultView: 'Widok domyślny',
  defaults: 'Domyślne',
  defaultsAndCapabilities: 'Wartości Domyślne i Możliwości',
  'delete': 'Usuń',
  deleteAll: 'Odziedzicz po Obiekcie Nadrzędnym',
  deleteAnyPartnerApiKeys: 'Usuń wszystkie klucze API partnera udostępnione SmartEquip.',
  deleteContent: 'Czy na pewno chcesz usunąć {type}? {name}',
  deleteFilesMessage: 'Czy na pewno chcesz usunąć plik(i) {count}?',
  deleteHotpointLinksTitle: 'Czy na pewno chcesz usunąć link(i) Hotpoint?',
  deleteMessage: 'Czy na pewno chcesz usunąć?',
  deletePart: {
    affectedCarts: 'Część zostanie usunięta ze wszystkich koszyków, w których się znajdowała.',
    deletingPartNumber: 'Element {partNumber} zostanie usunięty.',
    infoOne: 'Usunięcie części w bibliotece i sekcji administratora treści nastąpi natychmiastowo. Usunięta część będzie widoczna w wynikach wyszukiwania do momentu ponownej indeksacji, która nastąpi w ciągi kilku minut.',
    infoTwo: 'Tego działania nie można cofnąć bez pomocy działu wsparcia Documoto. Po 90 dniach usunięty rekord i wszystkie jego powiązania zostaną trwale wyczyszczone.'
  },
  deletePartCollectionConfirmMsg: 'Czy na pewno chcesz usunąć {partCollection} z {productPage}?',
  deletePartInUse: {
    body: 'Aktualnie Documoto umożliwia wyłącznie usuwanie części, które nie przynależą do stron. Usuń tę część ze wszystkich niepublikowanych lub roboczych stron, aby móc ją wykasować.',
    submitLabel: 'Przejdź do powiązanej strony',
    title: 'Ta część przynależy do stron i nie można jej usunąć.'
  },
  deleteProductPage: {
    deletingIdentifier: 'Element {identifier} zostanie usunięty.',
    infoOne: 'Usunięcie stron produktu w bibliotece i sekcji administratora treści nastąpi natychmiastowo. Usunięta strona produktu będzie widoczna w wynikach wyszukiwania do momentu ponownej indeksacji, która nastąpi w ciągu kilku minut.',
    infoTwo: 'Tego działania nie można cofnąć bez pomocy działu wsparcia Documoto. Po 90 dniach usunięty rekord i wszystkie jego powiązania zostaną trwale wyczyszczone.'
  },
  deleteRelated: 'Czy na pewno chcesz usunąć {count} {type}?',
  deleteSelectedCriteria: 'Usuń Wybrane Kryteria',
  deleteTagsTitle: 'Czy na pewno chcesz usunąć znacznik(i)?',
  deleteTaxonMessage: 'To spowoduje trwałe usunięcie tego taksonu razem z jego obiektami podrzędnymi. Czy na pewno chcesz kontynuować?',
  deleteTaxonomyMessage: 'To spowoduje trwałe usunięcie wszystkich taksonów tej Organizacji lub tego Dzierżawcy. Czy na pewno chcesz kontynuować?',
  deleteTenantSupplier: 'Czy na pewno chcesz usunąć tego dostawcę dzierżawcy?',
  deletedItem: '{item} Usunięto',
  demo: 'Demo',
  description: 'Opis',
  deselectAll: 'Usuń Wybór Wszystkiego',
  deselectCriteria: 'Odznacz Kryteria',
  detail: 'Szczegół | Szczegóły',
  diagonal: 'Przekątna',
  diameter: 'Średnica',
  disable: 'Wyłącz',
  disableAll: 'Wyłącz wszystko',
  disableDocumotoTenant: 'Zablokuj środowisko Documoto',
  disableFwdReindex: 'Wyłącz przekazywanie reindeksowanych multimediów docelowych dla DSW',
  disableLibraryBannerImage: 'Wyłącz obraz banera biblioteki',
  disableSmartEquipModalTitle: 'Czy na pewno chcesz zablokować tę licencję?',
  disableTEK: 'Dezaktywuje Login do Bezpośredniego URL',
  disableUserLogin: 'Wyłącz logowanie za pomocą nazwy użytkownika/hasła',
  disableUserLoginErrorMessage: 'Twoja organizacja wymaga uwierzytelniania SSO. Logowanie za pomocą nazwy użytkownika/hasła nie jest dozwolone w Twojej grupie użytkowników. Zaloguj się, korzystając z SSO.',
  disableUserLoginTooltip: 'Ta funkcja wymaga działającej konfiguracji SSO. Jeśli nie skonfigurowano logowania SSO, użytkownicy, których to dotyczy, utracą dostęp do Documoto.',
  disabled: 'Wyłączono',
  discard: 'Anuluj',
  discardChanges: 'Anuluj zmiany',
  discardQ: 'Anulować zmiany?',
  discountPrice: 'Promocyjna Cena',
  discounted: 'Z rabatem',
  discountedPrice: 'Cena z Rabatem',
  discountedTotal: 'Łącznie po Rabacie',
  displayInOrdersList: 'Wyświetl na Liście Zamówień',
  displayLocation: 'Lokalizacja wyświetlacza',
  displayOrder: 'Kolejność Wyświetlania',
  displayOrderDescription: 'Ustaw kolejność wyświetlania listy rozwijalnej Filtrów na potrzeby znaczników typu treści',
  displaySupplierPartInfo: 'Wyświetl dostawcę w informacjach o części',
  document: 'Dokument | Dokumenty',
  documentLabel: 'Dokument | Dokumenty',
  documentSettings: 'Ustawienia dokumentów',
  documotoAcademy: 'Documoto Academy',
  documotoLicensePackage: 'Pakiet licencji Documoto',
  domain: 'Domena',
  domainEmptyMessage: 'Dozwolona domena nie może być pusta',
  domainInvalidMessage: 'Wymagana poprawna nazwa domeny',
  download: 'Pobierz',
  downloadBrowser: 'Pobierz jedną z tych znakomitych przeglądarek.',
  downloadFailed: 'Błąd pobierania {name}',
  downloadStarted: 'Trwa pobieranie {name}',
  draft: 'Wersja Robocza | Wersje Robocze',
  draftBomDeleteTitle: 'Czy na pewno chcesz usunąć tę część ze strony?',
  draftBomDropError: 'Nie można zagnieżdżać części na ponad 5 poziomów wgłąb',
  draftBomEmptyField: 'Należy uzupełnić wszystkie pola na Liście Części',
  draftBomError: 'Błąd podczas przetwarzania projektów List Materiałowych',
  draftBomMultipleDeleteTitle: 'Czy na pewno chcesz usunąć te części ze strony?',
  draftBomQuantityError: 'Ilość musi być liczbą',
  draftPage: 'Strona Projektowa',
  draftPageDelete: 'Usuń Projekt',
  draftPageDeleteMessage: 'Projekt został usunięty.',
  draftPageDeleteWarning: 'Usunięcie projektu Strony spowoduje utratę aktualizacji postępów.',
  draftPageLastUpdated: 'Projekt – ostatnia aktualizacja dnia {date} przez użytkownika {username}',
  draftPageLoadError: 'Nie można wczytać strony z projektem.',
  draftPageProcessingPlz: 'Trwa ładowanie strony z pliku PLZ',
  draftPagePublishInProgress: 'Zadanie Publikacji Strony w toku',
  draftPageSaveSuccess: 'Strona projektowa została zapisana z powodzeniem.',
  draftPageSaveUnsuccessful: 'Strona projektowa nie została zapisana.',
  draftSheetImageHotpointsFailure: 'Nie można wygenerować {algorithm} punktów Hotpoints dla obrazu szkicu arkusza.',
  draftValidationMessage: {
    empty: 'Brak Błędów/Ostrzeżeń Walidacji',
    hotpointOrHotpointLink: 'Nie zdefiniowano żadnych punktów interaktywnych / łączy punktów interaktywnych dla pozycji {item} Zestawienia Materiałów',
    item: 'UWAGA: Brak określonego numeru pozycji dla numeru części {partNumber} na liście BOM',
    quantity: 'Nie zdefiniowano ilości dla pozycji {item} Zestawienia Materiałów',
    supersede: 'Część {partNumber} zastąpiono {supersededPartNumber} z powodu usunięcia.',
    tag: 'Brak wartości znacznika {tagName} pozycji {item} Zestawienia Materiałów',
    translationDescription: 'Brak opisu tłumaczenia na język {lang} dla pozycji {item} Zestawienia Materiałów',
    uom: 'Nie zdefiniowano jednostki miary dla pozycji {item} Zestawienia Materiałów'
  },
  drawAutohotpointRegion: 'Rozmiar rysowanego kształtu: {shape}',
  drawMinimumArea: 'Przeciągnij minimalny obszar',
  dropFileMessage: 'Upuść plik tutaj lub kliknij, aby przesłać.',
  duplicate: 'Powiel',
  duplicateSaveError: 'Powielony wpis. Nie można zapisać.',
  dutchDescription: 'Opis Niderlandzki',
  dutchName: 'Nazwa Niderlandzka',
  dynamic: 'Dynamiczne',
  dynamicNaming: 'Nazewnictwo Dynamiczne',
  ecommerce: 'Handel Elektroniczny',
  ecommerceEmailFormatCreated: 'Utworzono format wiadomości e-mail e-commerce',
  ecommerceEmailFormatSaved: 'Zapisano format wiadomości e-mail e-commerce',
  ecommerceLogo: 'Logo e-commerce',
  ecommerceUseExtOrder: 'Użyj zewnętrznego numeru zamówienia e-commerce',
  edit: 'Edytuj',
  editItem: 'Edytuj: {item}',
  email: 'E-mail',
  emailAsCsv: 'Wyślij w wiadomości e-mail jako plik CSV (wymagany format importu)',
  emailAsXlsx: 'Wyślij w wiadomości e-mail jako plik XLSX',
  emailBasicPartInfo: 'Wyślij podstawowe informacje o części w wiadomości e-mail',
  emailComments: 'Wyślij komentarze w wiadomości e-mail',
  emailDetails: 'Wyślij szczegóły w wiadomości e-mail',
  emailDisplayedCartColumns: 'Wyślij wyświetlane kolumny koszyka w wiadomości e-mail',
  emailFormat: 'Format wiadomości e-mail',
  emailFormatTemplate: 'Szablon formatu wiadomości e-mail | Szablony formatu wiadomości e-mail',
  emailList: 'Lista E-mailowa',
  emailMessage: 'Wymagany jest adres e-mail',
  emailRecipient: 'Odbiorca Wiadomości E-mail | Odbiorcy Wiadomości E-mail',
  emailRecipientMessage: 'Te adresy e-mail będą otrzymywać wiadomość e-mail, gdy status zamówienia zmieni się na',
  emailSubject: 'Wyślij temat w wiadomości e-mail',
  emptyBomState: 'Dla strony nie określono żadnych Pozycji z Listy Materiałowej. Kliknij +{add}, aby rozpocząć',
  emptyMessage: {
    orderSuggestions: 'Wygląda na to, że nie ma jeszcze Sugestii Zamówień dla tej części.'
  },
  enable: 'Włącz',
  enable3d: 'Włącz widok 3D',
  enable3dIllustrations: 'Włącz ilustracje 3D',
  enable3dThumbnails: 'Włącz miniatury 3D',
  enableAPIKeyAdmin: 'Włącz administratora klucza API',
  enableAll: 'Włącz wszystko',
  enableCommerce: 'Włącz Sprzedaż',
  enableEcommerceOrderManagement: 'Włącz zarządzanie zamówieniami',
  enableExportToLinkOne: 'Włącz eksportowanie do LinkOne',
  enableExportToSmartEquip: 'Włącz eksportowanie do SmartEquip',
  enableExporter: 'Włącz eksportera',
  enableIframeSupport: 'Włącz pomoc iFrame',
  enableKnowledgeBase: 'Włącz wyszukiwanie oparte na AI',
  enableLibraryBetaFeatures: 'Włącz funkcje beta biblioteki',
  enableMediaCategorySearch: 'Włącz grupowania według kategorii multimediów w wyszukiwaniu kontekstowym',
  enablePDFDownloadWarning: 'Włącz ostrzeżenie o pobieraniu dokumentu PDF o dużych rozmiarach',
  enablePLZToDraft: 'Włącz przetwarzanie plików PLZ do wersji roboczej',
  enablePerformanceLogging: 'Włącz rejestrowanie wyników',
  enableQuickAddToCart: 'Włącz funkcję Szybkiego dodawania do koszyka',
  enableQuickAddToCartHelpContext: 'Ustawienie „Włącz” nad przeglądarką spowoduje włączenie funkcji szybkiego dodawania do koszyka dla tej zawartości.',
  enableRocketUi: 'Włącz Rocket User Experience ',
  enableSmartEquipApiIntegration: 'Włącz integrację API SmartEquip',
  enableWidgetLogo: 'Włącz logo widżetu Documoto',
  enableWidgets: 'Włącz widżety',
  enabled: 'Włączono',
  encryptedKey: 'Klucz Szyfrowany',
  endDate: 'Data Zakończenia',
  endDateBad: 'Data rozpoczęcia musi być taka sama lub wcześniejsza od daty zakończenia.',
  enforceNumericSize: 'Wymuś Rozmiar Numeryczny',
  englishDescription: 'Opis Angielski',
  englishName: 'Nazwa Angielska',
  enterReportParameters: 'Wprowadź parametry raportu',
  enterUniqueNameForNewItem: 'Wprowadź unikalną nazwę nowego obiektu {item}',
  enterValidEmail: 'Wprowadź prawidłowy adres e-mail',
  enterValidNumber: 'Wprowadź prawidłową liczbę',
  enterprise: 'Enterprise',
  entityType: 'Typ Jednostki | Typy Jednostek',
  erp: 'ERP',
  erpEndpointConfig: 'Konfiguracja punktu końcowego ERP',
  erpPartInfo: 'Czas trwania pamięci podręcznej części ERP w minutach',
  erpSystem: 'System ERP',
  erpSystemSaved: 'System ERP zapisany',
  erpSystems: 'Systemy ERP',
  error: 'Błąd',
  errorDeletePageMessage: 'Podczas usuwania tej strony wystąpił błąd.',
  errorInputParsing: 'Problem z analizą pliku wejściowego.',
  errorPageMessage: 'Wystąpił błąd.',
  errorPageTitle: 'Coś poszło nie tak…',
  errorType: {
    error: 'Błąd',
    warning: 'Ostrzeżenie'
  },
  essential: 'Essential | Essentials',
  eta: 'Przewidywany czas dostawy',
  etlJob: 'ETL',
  exact: 'Dokładnie',
  excelFile: 'Plik Excel',
  existing: 'Istniejące',
  expandAll: 'Rozwiń Wszystko',
  'export': 'Eksportuj',
  exportAsCSVDropdown: 'Eksportuj jako CSV',
  exportAsCsv: 'Eksportuj jako Plik CSV (Wymagany Format Eksportu)',
  exportAsHtml: 'Wyeksportuj jako HTML',
  exportAsPdf: 'Eksportuj jako PDF',
  exportAsPlz: 'Eksportuj jako PLZ',
  exportAsXlsx: 'Eksportuj jako XLSX',
  exportBasicPartInfo: 'Eksportuj Podstawowe Informacje o Części',
  exportCartToXlsxDisabled: 'Wyłącz Eksport Koszyka do XLSX',
  exportCartToXlsxEnabled: 'Włącz Eksport Koszyka do XLSX',
  exportDisplayedCartColumns: 'Eksportuj Wyświetlane Kolumny Koszyka',
  exportJob: 'Zadanie Eksportu',
  exportLane: 'Eksportuj pas',
  exportMessage: 'Pomyślnie przesłano zadanie eksportu.',
  exportParts: 'Eksportuj Części',
  exportPartsXlsx: 'Eksportuj części do pliku XLSX',
  exportSearch: 'Eksportuj Wyszukiwanie',
  exporter: 'Eksporter',
  exporterMessage: 'Umożliwia eksportowanie treści',
  external: 'Zewnętrzny | Zewnętrzne',
  externalUrl: 'Zewnętrzny adres URL',
  faceted: 'Fasetowane',
  facetedTag: 'Wartości filtra muszą być fasetowe',
  facetedTagTooMany: 'Znacznik przekracza ograniczenie 1000 unikatowych wartości znaczników',
  failedAction: '{content} – niepowodzenie czynności {action}.',
  failedProcessContentSql: 'Przetwarzanie treści nie powiodło się ze względu na niedozwolony tekst. Ponownie prześlij obsługiwaną zawartość.',
  failedToCopy: 'Nie można skopiować elementu {content}.',
  failedToDelete: 'Nie udało się usunąć elementu {content}',
  failedToLoad: '{content} – niepowodzenie ładowania.',
  failedToSave: '{content} – niepowodzenie zapisywania.',
  failedToSubmitFeedback: 'Nie udało się przesłać opinii.',
  failedToSubmitItem: 'Nie udało się przesłać obiektu {item}',
  failedToUpdate: 'Nie można zaktualizować elementu {content}.',
  'false': 'Fałsz',
  faq: 'FAQ',
  favorites: 'Ulubione',
  favoritesLists: 'Lista Ulubionych',
  february: 'Luty',
  feedbackForm: 'Prześlij Informację Zwrotną',
  feedbackFormMessage: 'Wskaż funkcje, które chcesz zobaczyć',
  field: 'Pole | Pola',
  fieldDefinition: 'Definicja Pola',
  fieldName: 'Nazwa pola',
  file: 'Plik | Pliki',
  fileUpload: 'Przesyłanie pliku',
  filename: 'Nazwa Pliku',
  filesSubmitted: 'Przekazano plik(i) do przetwarzania',
  fill: 'Wypełnij',
  filter: 'Filtr | Filtry',
  filterBoundsError: 'Filtr musi zawierać 3 lub więcej znaków',
  filterBy: 'Filtruj Wg',
  filterOrgNameOnly: 'Filtr: Tylko Nazwa Org',
  filterOrgParentNames: 'Filtr: Nazwy Org i Nadrzędne',
  filterable: 'Filtrowane',
  filterableTag: 'Filtrowalny Znacznik',
  finnishDescription: 'Opis Fiński',
  finnishName: 'Nazwa Fińska',
  firstName: 'Imię',
  firstNameEmpty: 'Pole imienia nie może być puste',
  fixedHotpointSize: 'Stały Rozmiar Łącza Hotpoint',
  font: 'Czcionka | Czcionki',
  footer: 'Stopka',
  forSearchTerm: 'dla {term}',
  forgotPassword: 'Nie Pamiętam Hasła',
  forgotPasswordMessage: 'E-mail z instrukcją resetowania hasła zostanie wysłany do podanego użytkownika.',
  forgotPasswordSuccess: 'Jeśli podana nazwa użytkownika jest poprawna, na podany adres zostanie wysłany e-mail z instrukcją resetowania hasła.',
  form: 'Formularz | Formularze',
  formCount: 'Liczba Formularzy',
  formName: 'Nazwa formularza',
  formType: 'Rodzaj formularza',
  format: 'Format',
  formattingOptions: 'Opcje formatowania',
  freezeImage: 'Zablokuj obraz',
  frenchDescription: 'Opis Francuski',
  frenchName: 'Nazwa Francuska',
  fri: 'Pt',
  from: 'Od',
  fromDate: 'Data Od',
  frontCover: 'Okładka Przednia',
  frontStitch: 'Obszycie Przednie',
  fullScreen: 'Pełny ekran',
  gdprFaqs: 'RODO – Częste Pytania',
  gdprMessage: 'Logując się do tej sekcji naszej strony internetowej, wyrażasz zgodę na korzystanie przez nas z podstawowych plików cookie. Są one niezbędne do umożliwienia nawigacji po naszych usługach. Bez tych plików nie jesteśmy w stanie świadczyć żądanych usług. W celu uzyskania dodatkowych informacji patrz {policy}.',
  general: 'Ogólne',
  generalSearch: 'Wyszukiwanie Ogólne',
  generalSearchCriteriaAlreadySet: 'Kryteria wyszukiwania „Wyszukiwanie ogólne” są już ustawione.',
  generic: 'Ogólne',
  germanDescription: 'Opis Niemiecki',
  germanName: 'Nazwa Niemiecka',
  goTo: 'Przejdź do',
  goToHome: 'Przejdź do Strony Głównej',
  goToJobManager: 'Przejdź do Menedżera Zadań',
  goToPartCollections: 'Przejdź do {partCollections}',
  goToSearch: 'Przejdź do Wyszukiwania',
  gotIt: 'Rozumiem',
  hashKey: 'Klucz Skrótu',
  header: 'Nagłówek',
  headerAmpFooter: 'Nagłówek i Stopka',
  help: 'Pomoc',
  helpCenter: 'Centrum Pomocy',
  hideBookInSearchAndRecent: 'Ukrywaj Katalogi w Wynikach Wyszukiwania i Ostatnio Dodanych',
  hideDuplicatePages: 'Ukryj Duplikaty Stron',
  hidePageInSearchAndRecent: 'Ukrywaj Strony w Wynikach Wyszukiwania i Ostatnio Dodanych',
  hidePartInSearchAndRecent: 'Ukrywaj Części w Wynikach Wyszukiwania i Ostatnio Dodanych',
  highlightDescription: 'Oznacz tym znacznikiem części na liście części',
  history: 'Historia',
  home: 'Strona główna',
  homePageSettings: 'Ustawienia strony domowej',
  homepageOnly: 'Tylko strona główna',
  horizontal: 'Poziomo',
  host: 'Host',
  hotpoint: 'Punkt Aktywny | Punkty Aktywne',
  hotpointCalloutBehavior: 'Objaśnienie hotpointów',
  hotpointLink: 'Link Hotpoint | Linki Hotpoint',
  hotpointLinksWillBeCreated: 'Łącza Hotpoint zostaną utworzone w: {count} {content}',
  hotpointShift: 'Punkt Interaktywny (Shift H)',
  hotpointZoomBehavior: 'Przybliżanie hotpointów',
  hotpointsGenerated: 'Ilość najważniejszych punktów znalezionych na obrazie: {count}.',
  hourlyDWSRequestLimit: 'Godzinowy limit żądań DWS',
  hourlyRESTRequestLimit: 'Godzinowy limit żądań REST',
  htmlUiUserSwitchEnabled: 'Przełączanie użytkownika interfejsu HTML włączone',
  hungarianDescription: 'Opis Węgierski',
  hungarianName: 'Nazwa Węgierska',
  icon: 'Ikona',
  id: 'ID',
  identifier: 'Identyfikator',
  identifierRequiredErrorMessage: 'Wymagany jest identyfikator',
  ignore: 'IGNORUJ',
  ignoreAccessControls: 'Ignoruj Ustawienia Kontroli Dostępu',
  ignoreMatchingTranslations: 'Ignoruj tłumaczenia z dopasowanymi wersjami językowymi po imporcie',
  illustration: 'Ilustracja | Ilustracje',
  image: 'Obraz | Obrazy',
  imageDeleteMessage: 'Czy na pewno chcesz usunąć ten Obraz Strony?',
  imageDimensionsExceededMessage: 'Maksymalny rozmiar obrazu w Documoto wynosi 65,5 megapikseli (8191 X 8191 pikseli).  Obraz, który chcesz załadować, przekracza tę wartość i nie może zostać załadowany.  Kliknij "Zmień rozmiar", aby umożliwić Documoto zmianę rozmiaru obrazu i jego wprowadzenie, lub "Anuluj", aby edytować obraz i wprowadzić go ręcznie',
  imageOptimizer: 'Optymalizator Obrazów',
  imageSaveFail: 'Nie Można Zapisać Obrazu',
  imageSaveSuccess: 'Zaktualizowano Obrazy',
  imageSizeExceededMessage: 'Maksymalny rozmiar pliku obrazu dopuszczalny w Documoto wynosi {size} MB. Rozmiar obrazu, który próbujesz przesłać, przekracza maksymalny limit i nie można go załadować. Aby dodać obraz do tej strony, zmień jego rozmiar.',
  imageSizeExceededTitle: 'Przekroczono Maksymalny Rozmiar Obrazu',
  imageUploadFailure: 'Nie Można Przesłać Obrazu',
  'import': 'Importuj',
  importBOM: 'Importuj Zestawienie Materiałów',
  importBOMError: 'Nie można przetworzyć próbnych danych, sprawdź ponownie źródło danych',
  importName: 'Nazwa importu',
  importParts: 'Importuj Części',
  inCart: 'W Koszyku',
  inCartDescription: 'Wyświetl znaczniki w koszyku',
  inPartsList: 'Na Liście Części',
  inPartsListDescription: 'Wyświetl znaczniki na liście części',
  inch: 'Cal | Cale',
  includeComments: 'Dołącz Komentarze',
  includeCommentsAuthorAndDate: 'Dołącz Autora i Datę Komentarza',
  includeHeaderRow: 'Dołącz wiersz nagłówka',
  includeImages: 'Uwzględnij Obrazy',
  includeNewParts: 'Dołącz tylko „nowe” części (nie w Documoto)',
  includePagePartDetails: 'Dołącz szczegóły poziomu części ze strony',
  includePagesIndex: 'Uwzględnij Indeks Stron',
  includePartDetails: 'Dołącz szczegóły poziomu części',
  includePartsIndex: 'Uwzględnij Indeks Części',
  includePartsList: 'Uwzględnij Listę Części',
  includeSubChapters: 'Uwzględnij Podrozdziały',
  includeWatermark: 'Dodać znak wodny?',
  increaseHotpoint: 'Zwiększ Wartość Punktu Interaktywnego',
  indefinitely: 'Bezterminowo',
  indexIncludeTimestamp: 'Dołącz znacznik czasu',
  indexLane: 'Pas indeksowania',
  indexQueueJob: 'Kolejka indeksowania',
  indexed: 'Indeksowane',
  indexingConfiguration: 'Konfiguracja indeksowania',
  info: 'Informacje',
  information: 'Informacje',
  inherit: 'Dziedzicz',
  inherited: 'Dziedziczony',
  inheritedParent: 'Odziedziczone po Obiekcie Nadrzędnym.',
  inputSource: 'Źródło Danych',
  inputSpecification: 'Specyfikacja Wejściowa',
  inputType: 'Typ Danych Wejściowych',
  inputTypeListboxWarning: 'Konfiguracje sortowania zostaną wyświetlone po zapisaniu',
  insertDataField: 'Wstaw pole danych',
  integration: 'Integracja | Integracje',
  integrationsAddPartToErpCart: '{action} Dodaj Część do Koszyka ERP',
  integrationsAddToShoppingCartPricingFromErp: '{action} Dodaj Ceny do Koszyka z ERP',
  integrationsDisableErp: 'Wyłącz ERP',
  integrationsDoErpForQuotes: 'Wykorzystaj ERP do Wycen',
  integrationsEnableErp: 'Włącz ERP',
  integrationsEnableFetchPartInfoFromErp: 'Włącz Pobieranie Informacji o Części z ERP',
  integrationsEnableScopeErp: 'Włącz {scope} ERP',
  integrationsEnableSendShoppingCartToErp: 'Włącz Przesyłanie Koszyka do ERP',
  integrationsEnableSyncPoAddressWithErp: 'Włącz Synchronizację Adresu PO z ERP',
  integrationsErpAvailabilityMappedFrom: 'Mapowanie Dostępności z ERP',
  integrationsErpCurrencyCodeMappedFrom: 'Kod Waluty Mapowany z ERP',
  integrationsErpDiscountedPriceMappedFrom: 'Przewidywany czas Dostawy w Cenie z Rabatem Mapowany z ERP',
  integrationsErpEtaMappedFrom: 'Mapowanie Przewidywanego Czasu Dostawy z ERP',
  integrationsErpMappings: 'Mapowania ERP',
  integrationsErpRetailPriceMappedFrom: 'Przewidywany Czas Dostawy w Cenie Detalicznej Mapowany z ERP',
  integrationsErpWholesalePriceMappedFrom: 'Przewidywany Czas Dostawy w Cenie Hurtowej Mapowany z ERP',
  integrationsInvokeGetPartInfoFromClient: 'Pobierz Dane GetPartInfo od Klienta',
  integrationsParseAddressForType: 'Analizuj Adres Typu',
  integrationsShoppingCartAndPartsTitle: 'Koszyk i Części',
  integrationsShoppingCartAvailability: '{action} Dostępność Koszyka',
  integrationsShoppingCartEtaFromErp: '{action} Przewidywany Czas Dostawy z ERP',
  internalApiKey: 'Wewnętrzny klucz API',
  internalDescription: 'Opis Wewnętrzny',
  internalName: 'Nazwa Wewnętrzna',
  internalNameOptional: 'Twój identyfikator znacznika',
  internalNameRequired: 'Wymagana jest nazwa',
  invalidDecimals: 'Można wprowadzić tylko dwie cyfry po przecinku',
  invalidField: 'Wartość {field} jest nieprawidłowa',
  invalidFileType: 'Nieobsługiwany typ pliku. Pełną listę obsługiwanych rozszerzeń plików znajdziesz w Centrum Pomocy Documoto.',
  isSearchable: 'Jest Wyszukiwalne',
  isSystem: 'Jest Systemowe',
  italianDescription: 'Opis Włoski',
  italianName: 'Nazwa Włoska',
  item: '#',
  itemAlt: 'Pozycja',
  itemCopied: 'Skopiowano: {item}',
  itemDeleted: 'Usunięto: {item}',
  itemDetails: 'Szczegóły pozycji',
  itemInProgress: 'W toku: {item}',
  itemInformation: 'Informacje: {item}',
  itemMustBeLteItem: '{itemA} musi być równe lub niższe od {itemB}.',
  itemMustBeUnique: '{item} musi być unikalne',
  itemMustBeUniqueAndNotEmpty: '{item} musi być unikalne i jest wymagane',
  itemName: 'Nazwa: {item}',
  itemSaved: 'Zapisano: {item}',
  itemSpecification: 'Specyfikacja Pozycji',
  january: 'Styczeń',
  japaneseDescription: 'Opis Japoński',
  japaneseName: 'Nazwa Japońska',
  job: 'Zadanie | Zadania',
  jobManager: 'Menedżer Zadań',
  jobManagerMessage: 'Zadania eksportu, publikacji i druku/pobierania',
  july: 'Lipiec',
  june: 'Czerwiec',
  knowledgeBase: {
    config: {
      fetchUsage: 'Pobierz dane dotyczące użycia',
      maxTokensDefault: 'Domyślna maksymalna liczba tokenów na miesiąc',
      maxTokensOverride: 'Nadpisanie maksymalnej liczby tokenów na miesiąc',
      noData: 'Brak dostępnych danych konfiguracyjnych.'
    },
    errors: {
      maxFileSizeExceeded: 'Przekroczono limit rozmiaru pliku dla bazy wiedzy.',
      maxTokensExceeded: 'Osiągnięto limit tokenów.',
      pageNavigationFailed: 'Nie udało się przejść do strony.'
    },
    feedback: {
      prompt: 'Dziękujemy za poinformowanie nas o tym. Co było nie tak z tą odpowiedzią?',
      reasons: {
        hardToUnderstand: 'Trudna do zrozumienia',
        incorrect: 'Błędna',
        missingInfo: 'Brakujące informacje',
        offTopic: 'Nie na temat'
      },
      submitted: 'Twoja opinia została przesłana.'
    },
    library: {
      buttonText: 'Zapytaj AI',
      disclaimer: 'Documoto AI może popełniać błędy. Sprawdź poprawność odpowiedzi.',
      inputPlaceholder: 'Zadaj pytanie…',
      noContent: 'Brak dostępnego kontekstu dla tego dokumentu.',
      promptDefault: 'Odpowiedzi na pytania są udzielane wyłącznie na podstawie tego dokumentu. Zadawaj jedno pytanie naraz.',
      reference: 'Odniesienie PDF',
      serviceError: 'Błąd podczas generowania kontekstu.',
      title: 'Wyszukiwanie oparte na AI'
    },
    tenantKnowledgeBase: 'Baza wiedzy dzierżawcy',
    usage: {
      inputTokens: 'Łączna liczba tokenów wejściowych',
      noData: 'Brak dostępnych danych dotyczących użytkowania.',
      outputTokens: 'Łączna liczba tokenów wyjściowych',
      title: 'Podsumowanie użycia tokenów',
      totalTokens: 'Łączna liczba wykorzystanych tokenów'
    }
  },
  koreanDescription: 'Opis Koreański',
  koreanName: 'Nazwa Koreańska',
  label: 'Etykieta | Etykiety',
  labelKey: 'Klucz Etykiety',
  landscape: 'Format Poziomy',
  laneConfiguration: 'Konfiguracja pasa',
  language: 'Język',
  largePDFDownloadWarning: 'W związku z dużym rozmiarem pliku PDF załadowanie i wyświetlenie dokumentu w aplikacji może potrwać dłużej niż zwykle – prosimy o cierpliwość.',
  lastGenerated: 'Ostatnio Wygenerowane',
  lastModifiedDate: 'Data ostatniej modyfikacji',
  lastName: 'Nazwisko',
  lastNameEmpty: 'Pole nazwiska nie może być puste',
  lastUpdatedOn: 'Ostatnia aktualizacja',
  layout: 'Układ',
  layoutOptions: 'Opcje Układu',
  ledger: 'Rejestr',
  left: 'W lewo',
  legal: 'Legal',
  letter: 'Letter',
  library: 'Biblioteka',
  libraryAdmin: 'Administrator Biblioteki',
  libraryBannerLogo: 'Logo baneru biblioteki',
  librarySettings: 'Ustawienia Biblioteki',
  librarySettingsDescription: 'Te ustawienia dotyczą różnych elementów biblioteki. Zachowaj szczególną ostrożność przy wprowadzaniu zmian. Skontaktuj się z Documoto Services w celu uzyskania dodatkowych informacji.',
  licenseConfiguration: 'Konfiguracja licencji',
  line: 'Linia',
  lineTool: 'Narzędzie Linii',
  link: 'Link | Linki',
  listBox: 'Pole listy',
  listBoxValue: 'Wartość w Polu Listy | Wartości w Polu Listy',
  listValue: 'Wartość Listy | Wartości Listy',
  load: 'Załaduj',
  loadMore: 'Załaduj więcej',
  loading: 'Ładowanie',
  loadingParts: 'Ładowanie części',
  locale: 'Ustawienia regionalne',
  logiReportName: 'Nazwa Raportu Logi',
  logiReportToggle: 'Raport Logi?',
  login: 'Zaloguj',
  loginBackground: 'Tło Logowania',
  loginGDPRMessageBeginning: 'Ta strona internetowa wykorzystuje pliki cookie. Korzystając z tej strony, wyrażasz zgodę na używanie plików cookie. W celu uzyskania dodatkowych informacji patrz ',
  loginGDPRMessageEnd: 'oraz',
  loginSSO: 'SSO logowania',
  logo: 'Logo | Logo',
  logout: 'Wyloguj',
  lookupLoadParts: 'Wyszukaj/Załaduj Części z Documoto przy Imporcie',
  lowerBound: 'Niższe Powiązanie',
  mOfNShown: 'Widoczne {m} z {n}',
  mToM: 'M2M',
  mainInfo: 'Informacje Główne',
  mainLogo: 'Logo Główne',
  makePagesDivisibleBy: 'Wykonaj Strony Podzielne Przez:',
  manageItem: 'Zarządzaj {item}',
  management: 'Zarządzanie',
  manuallyResetPassword: 'Ręcznie resetuj hasło',
  manuallySetPassword: 'Ręcznie ustaw hasło',
  march: 'Marzec',
  margin: 'Marża | Marże',
  markdown: 'Markdown',
  maxCharHelpMessage: 'Ustaw dowolną wartość w przedziale od {min} do {max} dla maksymalnego limitu znaków.',
  maxCharacters: 'Maks. liczba znaków',
  may: 'Maj',
  media: 'Multimedia | Multimedia',
  mediaBookDeleteMessage: 'Usunięcie nośnika spowoduje usunięcie dostępu do tej treści zarówno w Bibliotece, jak i w Administratorze Treści i treści nie będą już dłużej dostępne dla użytkowników ani Administratorów Treści. Wszelkie części lub strony znajdujące się w tym katalogu, które nie występują w innych katalogach, także nie będą dłużej dostępne w Bibliotece.',
  mediaCategory: 'Kategoria Multimediów | Kategorie Multimediów',
  mediaCategoryEditor: 'Edytor Kategorii Multimediów',
  mediaCategoryName: 'Nazwa Kategorii Multimediów',
  mediaCategoryNameMissing: 'Wszystkie kategorie multimediów wymagają nazwy',
  mediaDeleteMessage: 'Skasowanie tego szablonu spowoduje usunięcie roli Administratora Treści i nie będzie możliwości późniejszego skopiowania do nowego Medium.',
  mediaDeleteSuccessText: 'Zostanie on usunięty z list po zakończeniu indeksowania.',
  mediaDescription: 'Opis multimediów',
  mediaIdentifier: 'ID multimediów',
  mediaIdentifierDescription: 'Wewnętrzny numer medium do wyszukiwania przez użytkowników końcowych',
  mediaName: 'Nazwa multimediów',
  mediaPrintSettingsSaveSuccess: 'Zapisano Ustawienie Drukowania Mediów',
  mediaWhereUsed: 'Wykorzystanie Multimediów',
  menu: 'Menu',
  merge: 'Scal',
  mergeOrOverrideMessage: 'Czy chcesz nadpisać czy połączyć te pozycje?',
  mergeWarning: 'Zaimportowanie danych spowoduje zaktualizowanie istniejących części i dodanie nowych pozycji',
  message: 'Wiadomość',
  messageLevel: 'Poziom Komunikatu',
  messageMessage: 'Wymagana jest wiadomość',
  metadata: 'Metadane',
  microsite: 'Mikrostrona | Mikrostrony',
  micrositeAdmin: {
    cardSubtitle: 'Plik ze skompresowaną zawartością oraz informacje dostępowe HTML',
    cardTitle: 'Zawartość strony',
    errorRequiredFile: 'Wymagany jest plik ZIP z zawartością strony',
    fieldFile: 'Plik ZIP z zawartością strony',
    fieldPoint: 'Punkt dostępu HTML'
  },
  minArea: 'Minimalne Pole',
  minAreaMessage: 'Wartość minimalna jest wymagana. Wartość musi się mieścić w zakresie od 1 do 1500.  Musi być liczbą całkowitą.',
  minCharacters: 'Min. liczba znaków',
  minMaxCharHelpMessage: 'Ustaw dowolną wartość w przedziale od {min} do {max} dla minimalnego/maksymalnego limitu znaków. Wartość maksymalna musi być wyższa od lub równa wartości minimalnej.',
  mine: 'Moje',
  miscellaneous: 'Różne',
  mon: 'Pn',
  month: 'Miesiąc',
  moreInfo: 'Więcej informacji',
  multipleAlternatingPages: 'Wiele Stron Alternatywnych',
  multipleAlternatingPagesMessage: 'Diagram na stronach 1 i 3, listy części na stronach 2 i 4.',
  multiplePages: 'Wiele Stron',
  multiplePagesMessage: 'Diagram na tej samej stronie z listą części poniżej',
  myCart: 'Mój koszyk | Moje Koszyki',
  nItemsCreated: 'Utworzono {n} {items}',
  nItemsDeleted: 'Usunięto {n} {items}',
  nOfMItems: '{n} z {m} {items}',
  name: 'Nazwa',
  nameDescriptionHelpText: 'Nazwa i opcjonalny opis',
  navigation: 'Nawigacja',
  'new': 'Nowe',
  newAPIKey: 'Nowy Klucz API',
  newERPSystem: 'Nowy system ERP',
  newItem: 'Nowa pozycja {item}',
  newKeyGenerated: 'Nowy Klucz Integracji Wygenerowany, Skopiowany i Zachowany do wykorzystania w przyszłości',
  newMediaCategory: 'Nowa Kategoria Multimediów',
  newPassword: 'Nowe Hasło',
  newTenant: 'Nowy dzierżawca',
  newWidgetKey: 'Nowy klucz widżetu',
  newWidgetKeyGenerated: 'Wygenerowano nowy klucz widżetu; skopiuj i zachowaj go do wykorzystania w przyszłości',
  newsItem: 'Aktualność | Aktualności',
  noAPIKeys: 'Brak zdefiniowanych Kluczy API.',
  noData: 'Brak Danych',
  noFileSelected: 'Nie wybrano pliku',
  noFilesSelected: 'Nie Wybrano Plików',
  noFormsMessage: 'Brak zdefiniowanych Formularzy.',
  noIllustrationFound: 'Nie Znaleziono Ilustracji',
  noImageFound: 'Nie Znaleziono Obrazu',
  noItemAddedToTarget: 'Żaden {item} nie został dodany do {target}. ',
  noItemAvailable: 'Niedostępne: {item}',
  noItemFound: 'Nie znaleziono pozycji {item}.',
  noItemSelected: 'Niewybrane: {item}',
  noItemsFound: 'Nie Znaleziono Pozycji',
  noMediaDefined: 'Brak zdefiniowanych multimediów',
  noMoreResults: 'Nie ma więcej wyników',
  noPartCollectionsFound: 'Nie znaleziono {partCollection}.',
  noPartsSelected: 'Nie wybrano części.',
  noPrice: 'Uzyskaj Wycenę',
  noResults: 'Brak wyników',
  noSearchResultsHelpText: 'Brak wyników',
  noSearchableCategories: 'Brak kategorii z możliwością wyszukiwania',
  noSearchableTags: 'Brak wyszukiwalnych tagów',
  noSuggestions: 'Brak sugestii dla wyszukiwanej frazy',
  noSupercedingPartsFoundForPartNumber: 'Nie znaleziono części zastępczych dla tego numeru części.',
  noTagsFound: 'Nie znaleziono tagów',
  noTenantSuppliers: 'Brak dostawców przypisanych do dzierżawcy.',
  noUnsavedChanges: 'Brak Niezapisanych Zmian',
  noWidgetKeys: 'Nie zdefiniowano żadnych kluczy widżetów.',
  node: 'Węzeł',
  nonSearchableFieldsSuccessfullyUpdated: 'Pomyślnie zaktualizowano pola bez możliwości wyszukiwania.',
  none: 'Brak',
  norwegianDescription: 'Opis Norweski',
  norwegianName: 'Nazwa Norweska',
  notAvailable: 'nd.',
  notImplemented: 'Niewdrożone',
  notMapped: 'Nie Zmapowano',
  notOrderable: 'Niemożliwe do Zamówienia',
  notSelected: 'Niezaznaczone',
  notification: 'Powiadomienie | Powiadomienia',
  notificationsMessage: 'Ważne ogłoszenia i aktualności',
  november: 'Listopad',
  numberOf: '# z {item}',
  numeric: 'Liczbowe',
  october: 'Październik',
  of: 'z',
  off: 'Wyłączone',
  offlineContent: 'Treści Offline',
  ok: 'OK',
  oldPassword: 'Stare hasło',
  on: 'Włączone',
  opacity: 'Przezroczystość',
  open: 'Otwórz',
  openItem: 'Otwórz {item}',
  openTab: 'Otwórz link w nowej karcie',
  optimizeIndexJob: 'Optymalizuj Indeks',
  optionalConfiguration: 'Opcjonalna konfiguracja | Opcjonalne konfiguracje',
  options: 'Opcje',
  order: 'Zamówienie | Zamówienia',
  orderAttachmentHelpText: 'Możesz załączyć maksymalnie 10 plików o rozmiarze 50 MB (każdy). Dozwolone typy plików: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg',
  orderDisable: 'Wyłącz Historię Zamówień',
  orderEmailRecipient: 'Odbiorca Wiadomości E-mail z Zamówieniem | Odbiorcy Wiadomości E-mail z Zamówieniem',
  orderEntity: 'Jednostka Kolejności | Jednostki Kolejności',
  orderField: {
    nameMessage: 'Jeśli zmienisz nazwę Pola Zamówienia/Wyceny, pamiętaj, aby zaktualizować wszystkie Formularze Zamówienia/Wyceny lub Formaty Wiadomości e-mail, które korzystają z tego pola.'
  },
  orderFieldCopyMessage: 'Podaj niepowtarzalną nazwę dla nowego Pola Zamówienia/Wyceny',
  orderFieldUneditableRequired: 'Ustawienie Pola Zamówienia/Wyceny jako wymaganego i niedostępnego do Edycji przez Użytkownika może uniemożliwić wypełnienie Formularza Zamówienia/Wyceny. Sprawdź, czy Formularze Zamówień/Wyceny mogą zostać wypełnione.',
  orderFieldsEmptyMessage: 'Nie zdefiniowano Pól Zamówienia/Wyceny.',
  orderFieldsEmptyPrompt: 'Dodaj Pole Zamówienia/Wyceny',
  orderForm: {
    uniqueNameInputHint: 'Wprowadź niepowtarzalną nazwę nowego Formularza.'
  },
  orderFormField: 'Pole Formularza Zamówienia/Wyceny | Pola Formularza Zamówienia/Wyceny',
  orderFormLayout: 'Układ Formularza Zamówienia/Wyceny | Układy Formularza Zamówienia/Wyceny',
  orderFormSetDefault: 'Ustawiony domyślny Formularz Zamówienia/Wyceny',
  orderFormType: 'Formularz zamówienia',
  orderLayout: 'Układ Zamówienia | Układy Zamówień',
  orderManagementApprover: 'Zatwierdzanie Zarządzania Zamówieniem',
  orderManagementDisable: 'Anuluj Administratora Zarządzania Zamówieniem',
  orderManagementViewer: 'Przeglądanie Zarządzania Zamówieniem',
  orderNumber: 'Numer Zamówienia',
  orderQuoteDeleteWarning: 'Nie można usunąć pól, które zostały zastosowane w formularzu zamówienia lub oferty, są używane w szablonie wiadomości e-mail albo zostały użyte w poprzednio złożonych zamówieniach lub ofertach.',
  orderQuoteEmail: 'Wiadomość e-mail z zamówieniem/zapytaniem | Wiadomości e-mail z zamówieniem/zapytaniem',
  orderQuoteEmailFormat: 'Format wiadomości e-mail z zamówieniem/zapytaniem | Formaty wiadomości e-mail z zamówieniem/zapytaniem',
  orderQuoteEmailFormatCopyMessage: 'Wybierz język dla nowego formatu wiadomości e-mail z zamówieniem/zapytaniem.',
  orderQuoteFetchError: 'Wystąpił błąd podczas pobierania danych zamówienia/zapytania',
  orderQuoteForm: 'Formularz zamówienia/wyceny | Formularze zamówienia/wyceny',
  orderQuoteFormSaved: 'Zapisano Formularz Zamówienia/Wyceny',
  orderQuoteSaveConfirmation: 'Zapisać zmiany w formularzach zamówienia/zapytania organizacji?',
  orderQuoteSaveError: 'Wystąpił błąd podczas zapisywania danych zamówienia/zapytania',
  orderStatus: 'Status Zamówienia/Wyceny | Statusy Zamówienia/Wyceny',
  orderStatusDeleteMessage: 'Ten status został wykorzystany w zamówieniach i nie można go usunąć.',
  orderSubmittedMessage: 'Pomyślnie Wysłano',
  orderSuggestion: 'Sugestia Zamówienia | Sugestie Zamówienia',
  orderSuggestionEnable: 'Włącz Sugestie Zamówienia',
  orderSuggestionRemovalWarning: 'Ta część nie będzie już wyświetlana jako sugestia zamówienia. | Te części nie będą już wyświetlane jako sugestie zamówienia.',
  orderSuggestionThreshold: 'Próg Sugestii Zamówienia',
  orderable: 'Możliwe do zamówienia',
  orderableDescription: 'Nie można dodać do koszyka i zakupić tej części',
  orderableLocal: 'Dostępne do zamówienia na tej stronie',
  orderableLocalBlocked: 'Część nie jest dostępna do Zamówienia Globalnie',
  ordersLogo: 'Logo Zamówień',
  ordersMessage: 'Historia przesłanych zamówień',
  org: 'Org',
  orgAccessControlsWarning: 'Uwaga: Organizacje przodków (np. rodziców lub dziadków) automatycznie uzyskują dostęp do treści przypisanych do organizacji ich potomków (np. dzieci lub wnuków).',
  orgEmailRecipients: 'Odbiorcy Wiadomości E-mail w Organizacji',
  orgNameOnly: 'Tylko Nazwa Org',
  organization: 'Organizacja | Organizacje',
  organizationAdmin: 'Administrator Organizacji',
  organizationAdminBrowseFlow: 'Organizacja może używać domyślnego przepływu przeglądania lub można go zastąpić i używać dowolnego innego przepływu przeglądania.',
  organizationAdminMessage: 'Kontroluje ustawienia zarządzania użytkownikami i organizacji',
  organizationEmailRecipients: 'Odbiorcy Wiadomości E-mail w Organizacji',
  organizationEmpty: 'Należy wybrać organizację',
  organizationEnforceAccessControlsForQuickAdd: 'Egzekwuj Kontrolę Dostępu dla Szybkiego Dodania',
  organizationKey: 'Klucz Organizacji',
  organizationLibrarySettingsDescription: 'Te ustawienia dotyczą różnych elementów Biblioteki i Opcji na Poziomie Organizacji. Zachowaj szczególną ostrożność przy wprowadzaniu zmian. Skontaktuj się z Documoto Services w celu uzyskania dodatkowych informacji.',
  organizationMoveToRoot: 'Upuść tutaj, aby przejść do katalogu głównego',
  organizationName: 'Nazwa organizacji',
  organizationRearrange: 'Zmień Ustawienia Organizacji',
  organizationRearrangeDescription: 'Pionowa struktura organizacyjna określa wiele dziedziczonych atrybutów Organizacji, takich jak Ustawienia Drukowania, Style i inne. Przeciągnij i upuść Organizacje, aby odzwierciedlić pożądaną hierarchię.',
  organizationReportSettingsSuccessMessage: 'Zapisano ustawienia raportu',
  organizationSelect: 'Wybierz Organizację',
  organizationTags: 'Znaczniki Organizacji',
  organizationsEmpty: 'Wygląda na to, że nie utworzono jeszcze organizacji',
  orientation: 'Orientacja',
  other: 'Inne',
  otherSettings: 'Inne Ustawienia',
  outboundCustomerIdParameter: 'Nazwa Parametru Zewnętrznego ID Klienta',
  outboundSessionIdParameter: 'Nazwa Parametru Zewnętrznego ID Sesji',
  outlineMode: 'Tryb Obrysu (Shift O)',
  output: 'Plik Wyjściowy',
  outputCatalog: 'Katalog Pliku Wyjściowego',
  outputDefinition: 'Definicja Pliku Wyjściowego | Definicje Plików Wyjściowych',
  outputDefinitionDeleted: 'Usunięto Definicję Pliku Wyjściowego',
  outputDefinitionSaved: 'Zapisano Definicję Pliku Wyjściowego',
  outputDestination: 'Lokalizacja docelowa',
  outputFileName: 'Nazwa Pliku Wyjściowego',
  outputName: 'Nazwa Pliku Wyjściowego',
  outputSpecification: 'Specyfikacja docelowa',
  outputSubType: 'Podtyp Pliku Wyjściowego',
  outputType: 'Typ Pliku Wyjściowego',
  overridden: 'Zastąpiono',
  overriddenByOrg: 'Zastąpiono przez Org.',
  override: 'Nadpisz',
  overrideBrowseFlow: 'Nadpisz Kierunek Przeglądania',
  overrideFacetLimitValue: 'Zastąp wartość graniczną aspektu',
  overrideFontSettings: 'Nadpisz Ustawienia Czcionki',
  overrideHotpointScale: 'Nadpisz Skalę Identyfikatora Hotpoint',
  overrideOrderForm: 'Zastąp formularz zamówienia',
  overridePdfNamingStandard: 'Nadpisz standard nazewnictwa plików PDF',
  overridePrintSettings: 'Nadpisz Ustawienia Drukowania',
  overrideQuoteForm: 'Zastąp formularz zapytania',
  overrideSvgOpacity: 'Nadpisz Przezroczystość SVG',
  overrideWarning: 'Zaimportowanie danych spowoduje zastąpienie bieżącej listy Zestawienia Materiałów',
  owner: 'Właściciel | Właściciele',
  page: 'Strona | Strony',
  pageBomPartsDeleted: '{count} części na stronie BOM nie będzie już dostępnych za pośrednictwem {filename}.',
  pageBuilder: 'Kreator Stron',
  pageBulkErrorTooManyBooks: 'Ogranicz liczbę wybranych książek do maksymalnie 1000',
  pageBulkInsertBooksConfirmInsertAfter: 'To spowoduje wstawienie {replacement} po {original} w {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertBefore: 'To spowoduje wstawienie {replacement} przed {original} w {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertReplace: 'To spowoduje wstawienie {replacement} i usunięcie {original} w {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertConfirmInsertAfter: 'To spowoduje wstawienie {replacement} po {original} w {whereUsedBookCount} {bookUnits} oraz {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertBefore: 'To spowoduje wstawienie {replacement} przed {original} w {whereUsedBookCount} {bookUnits} oraz {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertReplace: 'To spowoduje wstawienie {replacement} i usunięcie {original} w {whereUsedBookCount} {bookUnits} oraz {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmTitle: 'Czy na pewno chcesz zakończyć wprowadzanie zbiorcze?',
  pageBulkInsertDiscard: 'Wprowadzanie zbiorcze nie będzie przetwarzane.',
  pageBulkInsertHelpText: 'Ta funkcja pozwala wstawić stronę źródłową {thisDisplayName} do wybranych katalogów części, w których istnieje już inna strona {originalDisplayName}. Opcjonalnie można także usunąć {originalDisplayName} z tych katalogów.',
  pageBulkInsertInsertAfter: 'Wstaw {replacement} ZA {original}',
  pageBulkInsertInsertBefore: 'Wstaw {replacement} PRZED {original}',
  pageBulkInsertInsertReplace: 'Wstaw {replacement} i USUŃ {original}',
  pageBulkInsertScopeAll: 'Wszystkie {type}, których strona docelowa to {originalDisplayName} ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Żadne z {type}, których strona docelowa to {originalDisplayName}',
  pageBulkInsertScopeSome: 'Niektóre z {type}, których strona docelowa to {originalDisplayName}',
  pageBulkInsertStep1: 'Krok 1: Znajdź wybraną stronę docelową',
  pageBulkInsertStep2: 'Krok 2: Zdecyduj, jak wprowadzić lub zastąpić strony',
  pageBulkInsertStep3: 'Krok 3: Wybierz katalogi, do których chcesz wstawić zbiorczo strony.',
  pageBulkInsertStep4: 'Krok 4: Wybierz szablony, do których chcesz wstawić zbiorczo strony.',
  pageBulkInsertSuccessBody: 'Zmiany w spisie treści katalogów zostaną wprowadzone natychmiast. Wyniki wyszukiwania zostaną odzwierciedlone po zakończeniu indeksowania.',
  pageBulkInsertSuccessTitle: 'Przesłano zadanie wprowadzania zbiorczego',
  pageBulkInsertTemplatesConfirmInsertAfter: 'To spowoduje wstawienie {replacement} po {original} w {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'To spowoduje wstawienie {replacement} przed {original} w {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'To spowoduje wstawienie {replacement} i usunięcie {original} w {whereUsedTemplateCount} {templateUnits}.',
  pageComposer: 'Page Composer',
  pageCreated: 'Utworzono Stronę',
  pageDeleteMessage: 'Usunięcie stron w bibliotece i sekcji administratora treści nastąpi natychmiastowo. Usunięta strona będzie widoczna w wynikach wyszukiwania do momentu ponownej indeksacji, która nastąpi w ciągi kilku minut.',
  pageDeleteMessage2: 'Tego działania nie można cofnąć bez pomocy działu wsparcia Documoto. Po 90 dniach usunięty rekord i wszystkie jego powiązania zostaną trwale wyczyszczone.',
  pageDescription: 'Opis strony',
  pageDraftsDeleted: 'Strony robocze powiązane z tą stroną zostaną trwale usunięte.',
  pageFile: 'Plik Strony',
  pageFileRequired: 'Plik strony jest wymagany.',
  pageFilename: 'Nazwa pliku strony',
  pageFilenameDeleted: 'Element {filename} zostanie usunięty.',
  pageFit: 'Dopasowanie Strony',
  pageHeader: 'Nagłówek Strony',
  pageLabel: 'Strona | Strony',
  pageLayout: 'Układ Strony',
  pageName: 'Nazwa strony',
  pagePart: 'Część Strony | Części Strony',
  pagePartData: 'Dane Części na Stronie',
  pagePartLevelDetails: 'Części ze strony dostępne/widoczne, tagi części ze strony',
  pagePartNumberVisible: 'Numer Katalogowy na Stronie Widoczny',
  pagePartOrderable: 'Możliwość Zamówienia Części na Stronie',
  pagePartOrderableDescription: 'Możliwość Zamówienia Części na tej stronie',
  pagePartTag: 'Znacznik Części na Stronie | Znaczniki Części na Stronie',
  pagePartVisibleDescription: 'Numer Katalogowy widoczny na tej stronie',
  pageToPartCollectionFailure: 'Nie udało się dodać strony {name} jako kolekcji części.',
  pageUpdated: 'Zaktualizowano Stronę',
  pageUsageDataCouldNotBeLoaded: 'Nie można wczytać danych wykorzystania strony',
  pageViewer: 'Wyświetlarka Stron',
  pageWidth: 'Szerokość Strony',
  pagesWhereUsed: 'Strony w Użyciu',
  parentName: 'Nazwa Elementu Nadrzędnego',
  part: 'Część | Części',
  partCode: 'Kod Części | Kody Części',
  partCodeAddError: 'Nie można dodać Kodów Części',
  partCodeErrorEmpty: 'Nie można zapisać: Pole kodu części nie może być puste',
  partCodeErrorInUse: 'Ten kod części jest używany przez części w Documoto i nie może zostać usunięty. W celu uzyskania pomocy skontaktuj się z Pomocą Techniczną Documoto pod adresem support{\'@\'}documoto.com.',
  partCodeErrorNotFound: 'Ten kod części nie został usunięty, ponieważ nie można go było znaleźć, upewnij się, że wszystkie zmiany zostały zapisane.',
  partCodesManager: 'Menedżer Kodów Części',
  partCodesMessage: 'Kody części mogą być stosowane zamiast numerów części i często służą do wskazania, kiedy pozycje BOM są przestarzałe lub niedostępne albo służą tylko do celów orientacyjnych (np. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Kolekcja części | Kolekcje części',
  partCollectionsDescription: 'Dodaj nawet 20 {parts} {pages} do wyświetlenia jako {collections} na tej {productPage}.',
  partCollectionsDescription2: 'Wybrane {collections} określają, do których {parts} użytkownicy końcowi będą mieli szybki dostęp i możliwość zamówienia.',
  partCollectionsDescription3: 'Kolejność określona poniżej definiuje sposób ich wyświetlania w przeglądarce biblioteki {productPage}.',
  partCollectionsLimitError: 'Dozwolony limit to {limit} {item1} dla {item2}.',
  partCreated: 'Utworzono Część',
  partData: 'Dane Części',
  partDebouncerEmailQueueJob: 'Kolejka E-mailowa',
  partDescription: 'Opis strony',
  partEquipmentVerificationBanner: 'Baner weryfikacji wyposażenia części',
  partLabel: 'Część | Części',
  partLevelDetails: 'Ceny części, dostępne/widoczne, dodatkowe tłumaczenia, tagi części',
  partName: 'Nazwa Części',
  partNumber: 'Numer Części',
  partNumberCopied: 'Skopiowano {label} do schowka',
  partNumberDescription: 'Wewnętrzny numer części do wyszukiwania przez użytkowników końcowych',
  partNumberSupercededBy: '{partNumber} istnieje jako tag SupersededPartNumber w…',
  partNumberVisible: 'Widoczny Numer Części',
  partNumberVisibleDescription: 'Numer części jest widoczny dla użytkowników końcowych',
  partNumberVisibleLocal: 'Widoczne na tej stronie',
  partNumberVisibleLocalBlocked: 'Numer Części Niewidoczny Globalnie',
  partOrderable: 'Możliwość Zamówienia Części',
  partRequired: 'Wymagana jest przynajmniej jedna część',
  partTag: 'Znacznik Części | Znaczniki Części',
  partTagProperty: 'Właściwość Znacznika Części | Właściwości Znacznika Części',
  partUpdated: 'Zaktualizowano część',
  partVerificationInstructions: 'Sprawdź, czy ta część pasuje do Twojego sprzętu',
  partialSupport: 'Wsparcie Częściowe',
  partnerApiKey: 'Klucz API partnera',
  partnerRESTRequestLimit: 'Limit żądań REST dla partnera',
  partsBook: 'Katalog części | Katalogi części',
  partsBulkImport: {
    description: 'Prześlij plik danych, aby przesłać przetwarzanie importu zbiorczego części. Obsługiwany format pliku: XLSX.',
    downloadTemplate: 'Pobierz szablon XLSX',
    downloadUnprocessedRows: 'Pobierz arkusz kalkulacyjny nieprzetworzonych wierszy',
    hideRequirements: 'Ukryj wymagania XLSX',
    overwriteTagValues: 'Nadpisz wartości tagów dla pasujących tagów',
    overwriteTranslations: 'Nadpisz pasujące tłumaczenia',
    requirements: {
      discountPrice: {
        description: 'Ustawia cenę z rabatem na poziomie dzierżawcy.'
      },
      enUSDescription: {
        description: 'Przetłumaczony opis części dopasowany do danego języka. Zapoznaj się z naszym <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">przewodnikiem obsługi języków</a>.'
      },
      enUSName: {
        description: 'Przetłumaczona nazwa części dopasowana do danego języka. Dla nowych części wymagane jest co najmniej jedno tłumaczenie. Zapoznaj się z naszym <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">przewodnikiem obsługi języków</a>.'
      },
      orderable: {
        description: 'Określa, czy daną część można zamówić. Dozwolone wartości to `true` lub `false`. Domyślne ustawienie to `true`.'
      },
      orgDiscountPrice: {
        description: 'Ustawia cenę z rabatem dla określonej organizacji. Przykład nagłówka: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Ustawia cenę detaliczną dla określonej organizacji. Przykład nagłówka: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Ustawia cenę hurtową dla określonej organizacji. Przykład nagłówka: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Unikatowy identyfikator części.'
      },
      retailPrice: {
        description: 'Ustawia cenę detaliczną na poziomie dzierżawcy.'
      },
      supplier: {
        description: 'Nazwa dostawcy części.'
      },
      tagInternalName: {
        description: 'Przypisuje tagi do części. Nagłówek musi być nazwą wewnętrzną tagu. W przypadku kilku wartości użyj kreski pionowej (&#124;) jako separatora. Przykład: Czerwony&#124;Zielony&#124;Niebieski.'
      },
      thumbnail: {
        description: 'Nazwa pliku miniatury. Dozwolone rozszerzenia: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Jednostka miary (np. „każda sztuka”, „jednostka”).'
      },
      visible: {
        description: 'Określa, czy część jest widoczna. Dozwolone wartości to `true` lub `false`. Domyślne ustawienie to `true`.'
      },
      wholesalePrice: {
        description: 'Ustawia cenę hurtową na poziomie dzierżawcy.'
      }
    },
    showRequirements: 'Pokaż wymagania XLSX',
    submitNote: 'Kliknięcie przycisku „Wyślij” spowoduje rozpoczęcie zadania w tle i przekierowanie do strony „Menedżer zadań”.',
    success: 'Utworzono zadanie importu zbiorczego części',
    title: 'Import zbiorczy części'
  },
  partsColumns: 'Kolumny Części',
  partsDisplay: 'Wyświetlacz części',
  partsList: 'Lista Części',
  partsListColumn: 'Kolumna Listy Części | Kolumny Listy Części',
  partsListData: 'Dane Listy Części',
  partsListGridHeader: 'Nagłówek Siatki Listy Części',
  partsNotSelected: 'Domyślny obraz do wykorzystywania w miniaturkach. Jeśli nie zostanie zastosowana niestandardowa miniatura, Documoto wyświetli miniaturę domyślną.',
  partsPage: 'Strona z Częściami | Strony z Częściami',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Nie udało się załadować kolumn części',
    columnsUpdateErrorMsg: 'Wystąpił błąd podczas próby aktualizacji Kolumn Części',
    columnsUpdateSuccessMsg: 'Zaktualizowano Kolumny Części',
    cropWhitespaceOnImages: 'Przytnij białe pola na obrazach',
    excludePartCodesFromPartsLists: 'Wyklucz Kody Części z Listy Części',
    highlightAlternateRows: 'Podświetl Naprzemienne Wiersze',
    keepBOMOnRight: 'Wyrównaj BOM do Prawej Strony',
    keepImagesOnLeft: 'Wyrównaj Obrazy do Lewej Strony',
    printBorderAroundImages: 'Drukuj Ramkę Wokół Obrazów',
    printHotpointsOnImages: 'Drukuj Punkty Interaktywne na Obrazach',
    rotateImagesAutomatically: 'Obracaj Obrazy Automatycznie'
  },
  partsPages: 'Strony Części',
  password: 'Hasło',
  passwordBlankMessage: 'Pole hasła nie może być puste',
  passwordCannotBeSame: 'Nie może być takie samo jak obecne hasło',
  passwordCasingMassage: 'Musi zawierać co najmniej jedną małą i jedną wielką literę',
  passwordCriteriaInfo: 'Twoje nowe hasło musi spełniać następujące kryteria:',
  passwordExpiredHeader: 'Hasło wygasło',
  passwordExpiredInfo: 'Twoje hasło wygasło. Twoje nowe hasło musi spełniać następujące kryteria:',
  passwordLowerCaseMessage: 'Hasło musi zawierać co najmniej jedną małą literę',
  passwordMinLengthMessage: 'Hasła muszą zawierać co najmniej 8 znaków',
  passwordNotMatchingMessage: 'Hasła nie są identyczne',
  passwordOptions: 'Opcje hasła',
  passwordOptionsRequired: 'Opcje hasła nie mogą być puste',
  passwordSpecialCharactersMessage: 'Hasło musi zawierać co najmniej jeden znak specjalny',
  passwordUpperCaseMessage: 'Hasło musi zawierać co najmniej jedną wielką literę',
  passwordWillExpire1Day: 'Hasło do logowania wygaśnie za niecały 1 dzień',
  passwordWillExpire5Days: 'Hasło do logowania wygaśnie za niecałe 5 dni',
  passwordsMatch: 'Hasła są zgodne',
  pdfImport: {
    aiPdfImports: 'Importy PDF AI',
    aiPdfImportsDescription: 'Zarządzaj importami PDF AI w celu automatycznego przetwarzania treści.',
    createImport: 'Nowy import PDF AI',
    createImportDescription: 'Wybierz plik źródłowy PDF i skonfiguruj ustawienia wyodrębniania. Limit rozmiaru pliku: do 500 MB i 3000 stron.',
    defaultPartNumberCode: 'Domyślny kod numeru części',
    defaultTranslationLocale: 'Domyślna ustawienia regionalne tłumaczenia',
    defaultUomHelpText: 'Używane, gdy kolumna „Jednostka miary” nie została zmapowana lub gdy wyodrębniony wiersz listy materiałowej nie zawiera wartości jednostki miary.',
    defaultUomRequired: 'Wymagane, jeśli nie podano jednostki miary',
    dropFileMessage: 'Upuść plik tutaj lub kliknij, aby przesłać',
    fileSizeError: 'Rozmiar pliku przekracza limit 500 MB',
    importCreatedError: 'Nie udało się utworzyć importu',
    importCreatedSuccess: 'Pomyślnie utworzono import i zakolejkowano do przetworzenia',
    mapColumnToTag: 'Zmapuj kolumnę do tagu części ze strony',
    monthlyLimitExceeded: 'Przekroczony zostanie miesięczny limit dla importu PDF AI. Skontaktuj się z opiekunem klienta, aby uzyskać pomoc.',
    pageNumberFilterInvalidRange: 'Niewłaściwy zakres numeracji stron',
    pageNumberFilterPlaceholder: 'np. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Kod numeru części odnosi się do wierszy listy materiałowej, w których wartość numeru części jest pusta.',
    pdfImport: 'Importy PDF | Importy PDF',
    pdfImportsDescription: 'Zarządzaj importami plików PDF opartymi na AI, aby automatycznie wyodrębniać dane dotyczące części z dokumentów PDF.',
    publishModalFooterHelp: 'Kliknięcie przycisku „Opublikuj” spowoduje zakolejkowanie zadania i uruchomienie go w tle, a następnie przekieruje Cię z powrotem do strony menedżera importów PDF AI, gdzie możesz śledzić status publikacji.',
    publishSkipAutoHotpointing: 'Pomiń automatyczne wyznaczanie aktywnych punktów na stronie | Pomiń automatyczne wyznaczanie aktywnych punktów na stronach',
    publishingFinishedNone: 'Zakończono publikację importu „{importName}”. Nie opublikowano żadnych stron.',
    publishingFinishedPartial: 'Zakończono publikację importu „{importName}”. Opublikowane strony: {success}; niepowodzenie: {failed}. | Zakończono publikację importu {importName}. Opublikowane strony: {success}; niepowodzenie: {failed}.',
    publishingFinishedSuccess: 'Zakończono publikację importu „{importName}”. Opublikowane strony: {count}. | Zakończono publikację importu {importName}. Opublikowane strony: {count}.',
    reviewStatusAll: 'Status: Wszystko',
    reviewStatusApproved: 'Zatwierdzone',
    reviewStatusDropped: 'Porzucone',
    reviewStatusNoStatus: 'Brak statusu',
    reviewStatusNone: 'Brak',
    reviewStatusPending: 'Oczekujące',
    selectPagePartTag: 'Wybierz tag części ze strony',
    statusDeclined: 'Odrzucone',
    statusFailed: 'Niepowodzenie',
    statusPending: 'Oczekujące',
    statusProcessing: 'Przetwarzanie',
    statusPublished: 'Opublikowane',
    statusPublishing: 'Publikowanie',
    submitNote: 'Kliknięcie przycisku „Prześlij” spowoduje zakolejkowanie zadania i uruchomienie go w tle, a następnie przekieruje Cię z powrotem do strony menedżera importów PDF AI, gdzie możesz śledzić status importu.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Status dopasowania',
    columnPagePartTag: 'Tagi części ze strony',
    columnPartNameWithLocale: 'Nazwa części ({locale})',
    emptyState: 'Nie znaleziono pozycji listy materiałowej',
    existingPartNameApplied: 'Wykorzystano istniejące dane części',
    title: 'Lista materiałowa'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Dostosuj ramki ilustracji',
    boundsAdjusted: 'Dostosowano ramki',
    emptyState: 'Brak ilustracji dla tej strony.',
    hiresUnavailableError: 'Brak dostępnych obrazów w wysokiej rozdzielczości dla tej strony.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Zatwierdź wybrane ({count})',
    actionClearStatusSelected: 'Wyczyść status wybranych ({count})',
    actionCopySelected: 'Scal z pierwszą wybraną stroną',
    actionDeleteImport: 'Usuń import PDF AI',
    actionDropSelected: 'Porzuć wybrane ({count})',
    actionPendingSelected: 'Ustaw wybrane jako oczekujące ({count})',
    actionPublishSelected: 'Opublikuj wybrane',
    autoMergeAction: 'Scal automatycznie strony',
    autoMergeConfirmHelp: 'Funkcja „Scal automatycznie strony” wyszuka strony o tej samej nazwie i scali każdą pasującą grupę z pierwszą stroną w kolejności wyświetlania. Strony źródłowe scalone ze stroną docelową zostaną oznaczone jako „Porzucone”. Sprawdź wyniki przed publikacją.',
    autoMergeConfirmTitle: 'Scalić automatycznie strony z tymi samymi nazwami?',
    autoMergeFailed: 'Automatycznie scalanie nie powiodło się; nie doszło do żadnych zmian',
    autoMergeSuccess: 'Automatyczne scalanie zakończone: scalone grupy: {count}; porzucone strony: {dropped}',
    composedPageIndicator: 'Ta strona zawiera treści skopiowane z innych stron PDF.',
    contentTypeAll: 'Wszystkie rodzaje treści',
    contentTypeBomOnly: 'Tylko lista materiałowa',
    contentTypeBoth: 'Lista materiałowa i ilustracje',
    contentTypeEmpty: 'Puste strony',
    contentTypeFilterLabel: 'Rodzaj treści',
    contentTypeIllustrationsOnly: 'Tylko ilustracje',
    importSettings: 'Ustawienia importu',
    includeDroppedPagesLabel: 'Uwzględnij porzucone strony',
    incompleteBomFilterLabel: 'Pokaż strony z niepełną listą materiałową',
    mergeConfirmSourcePages: 'Wybrane strony źródłowe: {count} | Wybrane strony źródłowe: {count}',
    mergeConfirmTitle: 'Scalić wybrane strony z pierwszą wybraną stroną?',
    mergeConfirmTarget: 'Strona docelowa: {pageLabel}',
    mergeFailed: 'Nie udało się scalić stron z pierwszą wybraną stroną.',
    mergeSuccess: 'Strony scalone — strona docelowa: {pageLabel} (pozycje listy materiałowej {bomCount}; ilustracje: {illustrationCount})',
    noPages: 'Brak dostępnych stron',
    noPagesHint: 'Ten import nie zawiera żadnych stron',
    noResults: 'Nie znaleziono pasujących stron',
    noResultsHint: 'Spróbuj zmienić parametry lub filtry wyszukiwania',
    notificationLoadFailed: 'Nie udało się załadować przeglądu',
    notificationReviewStatusUpdated: 'Pomyślnie zaktualizowano {count} str.',
    notificationSelectAllFailed: 'Nie udało się wybrać wszystkich stron',
    notificationUpdateReviewStatusFailed: 'Nie udało się zaktualizować statusu recenzji',
    publishBookIdentifierNotUnique: 'Identyfikator katalogu musi być unikatowy.',
    publishBookIdentifierTakenHelp: 'Katalog z tym identyfikatorem już istnieje.',
    publishFailed: 'Nie udało się opublikować wybranych stron',
    publishModalTitle: 'Opublikuj wybrane strony',
    publishNewBookHelpText: 'Pomyślnie opublikowane strony zostaną dodane do nowego katalogu w tej samej kolejności, w jakiej pojawiają się w przeglądzie importu PDF AI. Nowy katalog zostanie utworzony tylko wtedy, gdy co najmniej jedna z wybranych stron zostanie pomyślnie opublikowana.',
    publishNewBookIdentifierLabel: 'Identyfikator katalogu',
    publishOptionNewBook: 'Utwórz nowy katalog i dodaj do niego strony',
    publishOptionPagesOnly: 'Opublikuj tylko strony',
    reviewManagement: 'Zarządzanie recenzją',
    reviewManagementTooltip: 'Wykorzystaj statusy recenzji, aby uporządkować swoją pracę podczas sprawdzania wyodrębnionych treści. Statusy Zatwierdzone, Oczekujące i Porzucone nie mają wpływu na publikację. Służą one wyłącznie do śledzenia postępów recenzji.',
    reviewProgress: 'Postęp recenzji',
    title: 'Informacje ogólne'
  },
  pdfImportPageDetails: {
    actionPublish: 'Opublikuj stronę',
    firstPage: 'Pierwsza strona',
    lastPage: 'Ostatnia strona',
    matchingPageNewPage: 'Nowa strona z częściami',
    matchingPageNewPageSharedSvg: 'Nowa strona z częściami, ale plik SVG jest dzielony z innymi stronami',
    matchingPageOpenExisting: 'Otwórz istniejącą stronę',
    matchingPageOverwrite: 'Istniejąca strona z częściami zostanie nadpisana',
    navLabel: 'Przegląd importu PDF AI',
    navigationFailedText: 'Nie udało się przejść do strony {pageNumber}',
    nextPage: 'Następna strona',
    notificationLoadFailed: 'Nie udało się załadować strony',
    notificationPublishFailed: 'Nie udało się przesłać zadania publikacji',
    notificationSaveFailed: 'Nie udało się zapisać strony',
    notificationSaveSuccess: 'Pomyślnie zapisano stronę',
    pageOriginComposed: 'Złożona z wielu stron PDF',
    pageOriginExtracted: 'Wyodrębniona z jednej strony PDF',
    pageOriginLabel: 'Źródło strony',
    previousPage: 'Poprzednia strona',
    publishPageModalHelpText: 'Ta strona z częściami zostanie opublikowana poza katalogiem. Publikacja spowoduje utworzenie nowej strony z częściami lub nadpisanie istniejącej, w zależności od reguł tożsamości strony.',
    thumbnailCardTitle: 'Miniatura strony PDF',
    viewBom: 'Lista materiałowa'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Utworzono',
    columnPdfPage: 'Strony PDF',
    columnPublishingStatus: 'Status publikacji',
    detailLoadFailed: 'Nie udało się załadować danych zadania publikacji',
    emptyBookOperations: 'W tym zadaniu nie zostały przeprowadzone żadne operacje katalogowe.',
    emptyJobsHint: 'Aktywność dotycząca publikacji pojawi się tutaj, gdy strony zostaną opublikowane.',
    emptyJobsTitle: 'Dla tego importu PDF AI nie zostały wykonane jeszcze żadne zadania publikacji.',
    emptyPagesTitle: 'Żadne strony nie pasują do wybranego filtra.',
    filterAllPages: 'Pokaż wszystkie strony',
    filterFailedOnly: 'Pokaż tylko strony z niepowodzeniem',
    filterNameQuery: 'Nazwa lub plik strony',
    filterPublishedOnly: 'Pokaż tylko opublikowane strony',
    helpText: 'Na tej stronie wyświetlana jest historia stron z częściami opublikowanych w ramach tego importu PDF AI, w tym stron utworzonych, nadpisanych lub których publikacja zakończyła się niepowodzeniem.',
    jobLabel: 'Zadanie nr {number}',
    loadFailed: 'Nie udało się załadować historii publikacji',
    resultPublishedCreated: 'Opublikowano – utworzono',
    resultPublishedUpdated: 'Opublikowano – nadpisano',
    resultSummaryBookCreated: 'Utworzono nowy katalog.',
    resultSummaryNone: 'Nie opublikowano żadnych stron.',
    resultSummaryPagesFailed: 'Strony z niepowodzeniem: {n}. | Strony z niepowodzeniem: {n}.',
    resultSummaryPagesPublished: 'Opublikowane strony: {n}. | Opublikowane strony: {n}.',
    statusFailed: 'Niepowodzenie',
    statusInProgress: 'W toku',
    title: 'Historia publikacji'
  },
  permission: 'Zezwolenie | Zezwolenia',
  phoneNumber: 'Numer Telefonu',
  phoneNumberExt: 'Wewn.',
  phonePrimary: 'Główny Numer Telefonu',
  phoneSecondary: 'Dodatkowy Numer Telefonu',
  pinFilter: 'Przypnij filtr do strony z wynikami wyszukiwania',
  pinned: 'Przypięte',
  plusMoreOrgs: '+ dodatkowe Organizacje: {totalOrgCount}',
  polishDescription: 'Opis Polski',
  polishName: 'Nazwa Polska',
  populatePdfNameSelection: 'Wybór sposobu uzupełnienia nazwy pliku PDF',
  populatePdfNameWith: 'Uzupełnij nazwę pliku PDF, używając',
  port: 'Port',
  portrait: 'Pionowo',
  portugueseDescription: 'Opis Portugalski',
  portugueseName: 'Nazwa Portugalska',
  postComment: 'Zamieść Komentarz',
  postalCode: 'Kod Pocztowy',
  poweredBy: 'Technologia',
  preferences: 'Preferencje',
  preferencesDisable: 'Wyłącz Ustawienia Użytkownika',
  prefix: 'Prefiks | Prefiksy',
  preview: 'Podgląd',
  previewOfName: 'Podgląd {name}',
  pricing: 'Cennik',
  pricingDiscountEnabled: 'Wyświetl Cenę z Rabatem',
  pricingDisplayInCart: 'Wyświetl Ceny w Koszyku',
  pricingDisplayInPartsList: 'Wyświetl Ceny na Liście Części',
  pricingGlobal: 'Globalny Cennik',
  pricingGlobalDescription: 'Normalna cena bez Zmian Organizacyjnych',
  pricingHideInitially: 'Ukryj wstępnie cenę',
  pricingHidePricingButton: 'Włącz Przycisk Ukrywania Ceny',
  pricingHidePricingButtonDisable: 'Wyłącz Przycisk Ukrywania Ceny',
  pricingHidePricingButtonDisableHelp: 'Wyłączenie przycisku „Ukryj ceny” sprawi, że użytkownicy nie będą w stanie wyświetlać/ukrywać poziomów cenowych. Każdy poziom cenowy skonfigurowany jako „Ukryj wstępnie cenę” pozostanie ukryty, a użytkownicy nie będą mogli go wyświetlić.',
  pricingOrganization: 'Cennik Organizacji',
  pricingOrganizationDeleteConfirm: 'Czy na pewno chcesz usunąć ten Cennik organizacji?',
  pricingOrganizationDescription: 'Cennik organizacji zastępuje cennik globalny dla wszystkich użytkowników w ramach organizacji i jej Organizacji podrzędnych.',
  pricingOrganizationDuplicate: 'Ta organizacja jest już zastąpiona',
  pricingOrganizationEmptyState: 'Nie określono zasad zastępowania organizacji. Kliknij {add}, aby rozpocząć.',
  pricingRetailEnabled: 'Wyświetl Cenę Detaliczną',
  pricingWholesaleEnabled: 'Wyświetl Cenę Hurtową',
  primary: 'Podstawowe',
  print: 'Drukuj',
  printJob: 'Zadanie Druku',
  printLogo: 'Drukuj logo',
  printSetting: 'Ustawienia Drukowania',
  printSettingCopyMessage: 'Wprowadź unikalną nazwę nowych Ustawień Drukowania.',
  printSettingCreated: 'Utworzono Ustawienia Drukowania',
  printSettingDeleteFail: 'Nie Udało się Usunąć Ustawień Drukowania',
  printSettingEmptyMessage: 'Nie zdefiniowano Ustawień Drukowania. Dodaj Ustawienia Drukowania, aby rozpocząć.',
  printSettingSaveFail: 'Nie Udało Się Zapisać Ustawień Drukowania',
  printSettingSelectionRequired: 'Wymagany wybór ustawień drukowania.',
  printSettingSetDefaultSuccess: 'Domyślny zestaw Ustawień Drukowania',
  printSettingUpdateFail: 'Nie Udało Się Zaktualizować Ustawień Drukowania',
  printSettings: 'Ustawienia Drukowania',
  printSettingsLogo: 'Logo Ustawień Drukowania',
  printerLane: 'Pas drukarki',
  printing: 'Drukowanie',
  printingDisabled: 'Wyłącz Drukowanie',
  privacyPolicy: 'Polityka Prywatności',
  proceed: 'Kontynuuj',
  process: 'Przetwórz',
  processContent: 'Przetwarzaj Zawartość',
  processToDraft: 'Przetwarzaj do wersji roboczej',
  processedPlzToDraft: 'Pliki PLZ przetworzone do wersji roboczej',
  processing: 'Przetwarzanie',
  productCategory: 'Kategoria produktu | Kategorie produktów',
  productCategoryName: 'Nazwa kategorii produktu',
  productId: 'Identyfikator produktu',
  productIdErrorMessage: 'Wymagany jest identyfikator produktu',
  productIdMessage: 'Wartość identyfikatora, której użytkownicy będą używać do znalezienia produktu, np. „FTX1000”',
  productPage: 'Strona produktu | Strony produktu',
  productPageAccessControlDescription: 'Kontrola dostępu definiuje, kto może zobaczyć tę stronę na podstawie przypisań do organizacji i grup użytkowników.',
  productPageCreated: 'Utworzono stronę produktu',
  productPageDescription: 'Opis strony produktu',
  productPageIdentifierMessage: 'Niepowtarzalny wewnętrzny identyfikator tej strony',
  productPageName: 'Nazwa strony produktu',
  productPageProductId: 'Strona produktu – identyfikator produktu',
  productPageUpdated: 'Zaktualizowano stronę produktu',
  productPagesBulkImport: {
    description: 'Prześlij plik z danymi, aby uruchomić proces zbiorczego importu stron produktów. Obsługiwany format plików: XLSX.',
    downloadUnprocessedRows: 'Pobierz arkusz kalkulacyjny nieprzetworzonych wierszy',
    overwriteAccessControls: 'Nadpisz funkcje kontroli dostępu (organizacje i grupy użytkowników)',
    overwriteAssociatedMedia: 'Nadpisz powiązane multimedia',
    requirements: {
      enUSCategory: {
        description: 'Istniejąca nazwa kategorii produktu wybranych ustawień regionalnych. Zapoznaj się z naszym <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">przewodnikiem obsługi języków</a>.'
      },
      enUSDescription: {
        description: 'Przetłumaczony opis strony z częściami dopasowany do danego języka. Zapoznaj się z naszym <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">przewodnikiem obsługi języków</a>.'
      },
      enUSName: {
        description: 'Przetłumaczona nazwa strony z częściami dopasowana do danego języka. Dla nowych stron produktów wymagane jest co najmniej jedno tłumaczenie. Zapoznaj się z naszym <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">przewodnikiem obsługi języków</a>.'
      },
      identifier: {
        description: 'Unikatowy identyfikator strony produktów, który można wyszukać i wyświetlić wyłącznie w centrum administracyjnym.'
      },
      media: {
        description: 'Lista identyfikatorów multimediów powiązanych z wybraną stroną produktów. W przypadku kilku wartości użyj kreski pionowej (&#124;) jako separatora.'
      },
      organizations: {
        description: 'Lista organizacji z dostępem do wybranej strony produktów. W przypadku kilku wartości użyj kreski pionowej (&#124;) jako separatora.'
      },
      productId: {
        description: 'Identyfikator strony produktów dla użytkowników końcowych, który można wyszukać i wyświetlić w bibliotece. Identyfikator produktu nie musi być wartością unikatową.'
      },
      tagInternalName: {
        description: 'Przypisz tagi do strony produktów. Nagłówek musi być nazwą wewnętrzną tagu. W przypadku kilku wartości użyj kreski pionowej (&#124;) jako separatora. Przykład: Czerwony &#124; Zielony &#124; Niebieski.'
      },
      thumbnail: {
        description: 'Nazwa pliku miniatury. Dozwolone rozszerzenia: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Lista grup użytkowników z dostępem do wybranej strony produktów. W przypadku kilku wartości użyj kreski pionowej (&#124;) jako separatora.'
      }
    },
    success: 'Utworzono zadanie zbiorczego importu stron produktów',
    title: 'Zbiorczy import stron produktów'
  },
  production: 'Produkcja',
  professional: 'Professional',
  profile: 'Profil',
  prohibitExportDownloadOfContent: 'Zabroń eksportowania/pobierania zawartości',
  prohibitExportDownloadOfContentHelpText: 'Zaznaczenie „Włącz” uniemożliwi każdemu użytkownikowi (z uprawnieniami) eksportowanie i pobieranie tej zawartości.',
  property: 'Właściwość | Właściwości',
  province: 'Prowincja',
  'public': 'Publiczne',
  publish: 'Publikuj',
  publishDocuments: 'Opublikuj Dokumenty',
  publishDraft: 'Opublikuj Wersję Roboczą',
  publishThumbnailJob: 'Opublikuj Miniaturę',
  publisher: 'Publikator | Publikatory',
  publisherJob: 'Zadanie Publikatora',
  publisherLane: 'Pas publikacji',
  publisherManualLane: 'Ręczny pas publikacji',
  publisherMessage: 'Ustawienia tworzenia treści, zarządzania i drukowania',
  publishingErrors: 'Błędy w Publikacji',
  publishingErrorsWithName: 'Błędy Publikacji {name}',
  publishingInProgress: 'Trwa publikowanie, nie można przesłać',
  purchaseOrder: 'Zamówienie Zakupu',
  purchaseOrderTemplateDisabled: 'Wyłącz Szablony Zamówienia',
  purchaseOrderTemplateEnabled: 'Włącz Szablony Zamówienia',
  qty: 'Il.',
  quantity: 'Ilość',
  query: 'Zapytanie',
  quickAdd: 'Szybkie Dodawanie',
  quickAddHelpText: 'Zacznij wpisywać, aby znaleźć części i dodać je do koszyka.',
  quickAddInCartEnabled: 'Włącz Szybkie Dodawanie do Koszyka',
  quickLinks: 'Szybkie Łącza',
  quote: 'Wycena | Wyceny',
  quoteFormType: 'Formularz zapytania',
  quoteTemplateDisabled: 'Wyłącz Szablony Wycen',
  quoteTemplateEnabled: 'Włącz Szablony Wycen',
  range: 'Zakres',
  rearrange: 'Ustaw Ponownie',
  rebuildIndexJob: 'Utwórz Indeks Ponownie',
  recentSearches: 'Ostatnie wyszukiwania',
  recentlyAdded: 'Ostatnio Dodane',
  recentlyEdited: 'Ostatnio Edytowane',
  recentlyViewed: 'Ostatnio Wyświetlane',
  recipientOrRecipients: 'Odbiorca(-y)',
  rectangle: 'Prostokąt',
  redirect: 'Przekieruj',
  refresh: 'Odśwież',
  related: 'Powiązane',
  relatedDescription: 'Powiąż multimedia występujące w bibliotece z tym {type}. Uwaga, powiązane multimedia muszą mieć zastosowaną kontrolę dostępu, aby użytkownicy mogli je zobaczyć w zakładce \'Powiązane\'.',
  relatedInfo: 'Informacje Powiązane',
  relatedView: 'Zobacz Powiązane Multimedia',
  relationship: 'Powiązanie | Powiązania',
  releaseNotes: 'Informacje o Wydaniu',
  remainingWidth: 'Pozostała Szerokość',
  rememberMe: 'Zapamiętaj mnie',
  remove: 'Usuń',
  removeAll: 'Usuń Wszystko',
  removeItemConfirmation: 'Czy na pewno chcesz usunąć {item}?',
  removeItemCount: 'Czy na pewno chcesz usunąć {count} {type}?',
  replace: 'Zastąp',
  replaceExisting: 'Zamień Istniejące',
  report: 'Raport | Raporty',
  reportAnIssue: 'Zgłoś Problem',
  reportAnIssueMessage: 'Pomyślnie wysłano e-mail.',
  reportCatalogName: 'Nazwa Katalogu z Raportem',
  reportCatalogNotSet: 'Nie określono katalogu dla raportu.',
  reportDefinition: 'Definicja Raportu | Definicje Raportu',
  reportDefinitionDeleteError: 'Nie usunięto definicji raportu',
  reportExportTimeWarning: 'W zależności od liczby wpisów i wybranego formatu eksport może zająć do kilku minut.',
  reportSettings: 'Ustawienia Raportów',
  reporting: 'Raportowanie',
  reportingMessage: 'Dostęp do różnych raportów i miar',
  reportsEmptyState: 'Brak Raportów',
  reportsLibrary: 'Biblioteka Raportów',
  requestForQuote: 'Zapytanie Ofertowe',
  requestFormType: 'Formularz zapytania',
  requireAuthentication: 'Wymagane Uwierzytelnienie',
  required: 'Wymagane',
  requiredField: 'Pole Wymagane',
  requiredItem: 'Wymagany jest obiekt {item}.',
  requiredMessage: 'Wymagany jest obiekt {item}.',
  requiredMessageAndUnique: 'Element {item} jest wymagany i musi być unikatowy.',
  requiredReading: 'Wymagana Lektura',
  requiredReadingMessage: 'Przejrzyj poniższe informacje:',
  requiredType: 'Wymagany jest typ.',
  requiredUrlMessage: 'Wymagany jest poprawnie sformułowany adres URL.',
  reset: 'Resetuj',
  resetPassword: 'Resetuj Hasło',
  resetPasswordError: 'Wystąpił problem podczas resetowania hasła, spróbuj ponownie.',
  resetPasswordTokenError: 'Token resetowania hasła jest nieprawidłowy.',
  resetZoom: 'Resetuj Powiększenie',
  resize: 'Zmień rozmiar',
  resizeThumbnails: 'Automatycznie zmieniaj rozmiar miniatur',
  resource: 'Zasób | Zasoby',
  result: 'Wynik | Wyniki',
  resultFor: 'Wynik dla pozycji {item} | Wyniki dla pozycji {item}',
  retail: 'Sprzedaż Detaliczna',
  retailPrice: 'Cena Detaliczna',
  retailTotal: 'Łączna Cena Detaliczna',
  'return': 'Powrót',
  returnToItem: 'Powróć do elementu {item}',
  returnToMedia: 'Powróć do Multimediów',
  returnToPartList: 'Powróć do Listy Części',
  returnToTemplate: 'Wróć do Szablonu',
  returnToViewer: 'Powrót do podglądu',
  revert: 'Cofnij',
  revertChanges: 'Cofnij Zmiany',
  revertChangesMsg: 'Czy na pewno chcesz cofnąć zmiany?',
  right: 'W prawo',
  romanianDescription: 'Opis Rumuński',
  romanianName: 'Nazwa Rumuńska',
  rootLevelBrowseFlow: 'Główny Poziom',
  row: 'Wiersz',
  russianDescription: 'Opis Rosyjski',
  russianName: 'Nazwa Rosyjska',
  s3DataExportsEnabled: 'Włącz eksport danych S3',
  sampleData: 'Przykładowe Dane',
  samplePreview: 'Przykładowy podgląd',
  sandbox: 'Piaskownica',
  sat: 'So',
  save: 'Zapisz',
  saveAndClose: 'Zapisz i zamknij',
  saveAndEditTarget: 'Zapisz i edytuj cel',
  saveChanges: 'Czy zapisać zmiany w {item}? {name}',
  saveChangesToItem: 'Czy zapisać zmiany w {item}?',
  saveNewAPIKey: 'Nowy Klucz Integracji nie został Zapisany, Wróć do pełnej konfiguracji',
  saveNewWidgetKey: 'Nie zapisano nowego klucza widżetu. Wróć, aby dokończyć konfigurację.',
  saveOrderAttachmentsError: 'Zapis załączników do zamówienia nie powiódł się.',
  saved: 'Zapisz',
  search: 'Wyszukaj',
  searchAllContent: 'Przeszukaj całą zawartość',
  searchCategories: 'Kategorie',
  searchConfiguration: 'Konfiguracja wyszukiwania',
  searchContent: 'Wyszukaj {content}',
  searchCriteria: 'Kryteria Wyszukiwania',
  searchDocumoto: 'Wyszukaj w Documoto',
  searchFeatures: 'Funkcje wyszukiwania',
  searchFieldConfigDescription: 'Wskazane ustawienia wyszukiwania w polach systemowych mają zastosowanie wyłączenie do ogólnego wyszukiwania w bibliotece, strony z wynikami wyszukiwania oraz opcji szybkiego dodawania do koszyka. Nie wpłyną one na inne opcje wyszukiwania (jak wyszukiwanie w centrum administracyjnym oraz powiązanej bibliotece).',
  searchInContent: 'Wyszukaj w {contentName}...',
  searchPlaceholder: 'Przeszukaj całą zawartość…',
  searchPrompt: 'Przeszukaj całą zawartość…',
  searchProperty: 'Właściwość Wyszukiwania | Właściwości Wyszukiwania',
  searchResults: 'Wyniki wyszukiwania',
  searchResultsConfiguration: 'Konfiguracja wyników wyszukiwania',
  searchSettings: 'Ustawienia wyszukiwania',
  searchSettingsDescription: 'Te ustawienia odnoszą się do różnych zachowań, funkcji i wyników wyszukiwania w bibliotece.',
  searchTerm: 'Termin Wyszukiwania',
  searchTips: 'Wskazówki dotyczące wyszukiwania:',
  searchType: 'Typ',
  searchable: 'Wyszukiwalne',
  searchableFieldsSuccessfullyUpdated: 'Pomyślnie zaktualizowano pola z możliwością wyszukiwania.',
  searchableTag: 'Wyszukiwalny Znacznik',
  searchingInLanguage: 'Szukanie {lang} tylko w',
  searchingInTwoLanguages: 'Szukanie tylko w {lang1} i {lang2}',
  section: 'Sekcja',
  select: 'Wybierz',
  selectAField: 'Wybierz: {field}',
  selectAll: 'Wybierz Wszystko',
  selectAndClose: 'Wybierz i Zamknij',
  selectChapters: 'Wybierz Rozdziały',
  selectChildren: 'Wybierz Element Podrzędny',
  selectFields: 'Wybierz {fields}',
  selectItem: 'Wybierz {item}',
  selectMedia: 'Wybierz Multimedia',
  selectPage: 'Wybierz Stronę',
  selectPages: 'Wybierz Strony',
  selectTargetPage: 'Wybierz Stronę Docelową',
  selected: 'Wybrano',
  selectedTargetPage: 'Wybierz Stronę Docelową',
  send: 'Wyślij',
  sendReverificationEmail: 'Wyślij wiadomość e-mail dotyczącą weryfikacji',
  sendVerificationEmail: 'Wyślij wiadomość e-mail dotyczącą ponownej weryfikacji',
  september: 'Wrzesień',
  sequence: 'Kolejność',
  serbianDescription: 'Opis Serbski',
  serbianName: 'Nazwa Serbska',
  serviceUri: 'URI Usługi',
  sessionLog: 'Dziennik sesji',
  set: 'Ustaw',
  setAsDefault: 'Ustaw jako Domyślne',
  setPassword: 'Ustaw hasło',
  settings: 'Ustawienia',
  settingsMessage: 'Aktualizuj preferencje użytkownika i hasło',
  shape: 'Kształt',
  shapeTool: 'Narzędzie Kształtu',
  shared: 'Udostępnione',
  sharedCart: 'Koszyk Współdzielony | Koszyki Współdzielone',
  sharedCartDeleteContent: 'Spowoduje to usunięcie tego Współdzielonego Koszyka z wszystkich Organizacji, w których został on udostępniony.',
  sharedCartOrganizationContent: 'Wybierz Organizacje, które mogą korzystać z tego Współdzielonego Koszyka.',
  sharedShoppingCartsEnabled: 'Włącz Koszyki Współdzielone',
  shoppingCartExportJob: 'Eksport Koszyka',
  shoppingCartLoadingLongTime: 'Trwa ładowanie koszyka. Ikony koszyka będą dostępne po zakończeniu procesu. Jeśli problem nie ustąpi, skontaktuj się z administratorem Documoto, aby uzyskać wsparcie.',
  showChapterTOCForHiddenPages: 'Pokaż Spis Treści Rozdziału dla Ukrytych Stron',
  showExportFromSearch: 'Zezwól na Eksport Wyników Wyszukiwania',
  showExportFromSearchHelp: 'Zezwól na eksport listy katalogów z wyników wyszukiwania',
  showHelp: 'Wyświetl pomoc',
  showIdentifierInLibrary: 'Wyświetl identyfikatory mediów i stron produktów w bibliotece',
  showIdentifierInSearch: 'Wyświetl identyfikator nośnika w wyszukiwaniu',
  showItem: 'Pokaż {item}',
  showLess: 'Pokaż Mniej',
  showMediaDescriptionFilter: 'Pokaż Filtr Opisu Nośnika',
  showMediaIdentifierFilter: 'Pokaż Filtr Identyfikatora Nośnika',
  showMediaNameFilter: 'Pokaż Filtr Nazwy Nośnika',
  showMore: 'Pokaż Więcej',
  showOnlyExactMatches: 'Pokaż tylko dokładne dopasowania',
  showOrganizationFilter: 'Pokaż Filtr Organizacji',
  showPartNameFilter: 'Pokaż Filtr Nazwy Części',
  showPartNumberFilter: 'Pokaż Filtr Numeru Części',
  showRecentlyAdded: 'Pokaż Ostatnio Dodane',
  showRecentlyViewed: 'Pokaż Ostatnio Wyświetlane',
  showSearchButton: 'Pokaż Przycisk Wyszukiwania na Stronie Głównej',
  showSearchButtonHelp: 'Pokaż przycisk \'Przejdź do Wyszukiwania\' w nagłówku Biblioteki',
  signature: 'Podpis',
  size: 'Rozmiar',
  snapshot: 'Migawka | Migawki',
  solrSlaveSvrOverride: 'Zastąp podstawowe adresy URL wtórnych serwerów SOLR',
  sortAsc: '{value} A–Z',
  sortDesc: '{value} Z–A',
  sortRelevant: 'Najtrafniejsze',
  sortType: 'Sortuj wg Typu',
  sourceBrowseFlow: 'Źródłowy kierunek przeglądania',
  sourceFile: 'Plik źródłowy',
  sourceFilename: 'Nazwa pliku źródłowego',
  spanishDescription: 'Opis Hiszpański',
  spanishName: 'Nazwa Hiszpańska',
  square: 'Kwadrat',
  ssoConfiguration: 'Konfiguracja SSO',
  ssoIdpMetadataUrl: 'Adres URL metadanych dostawcy tożsamości SSO',
  ssoLoginMaxAuthenticationAgeSeconds: 'Maksymalny czas uwierzytelniania w sekundach dla logowania SSO',
  ssoSamlDnAttributeName: 'Nazwa atrybutu nazwy wyróżniającej dla SAML logowania SSO',
  ssoSamlEmailAttributeName: 'Nazwa atrybutu adresu e-mail dla SAML logowania SSO',
  ssoSamlMemberofAttributeName: 'Nazwa atrybutu członka dla SAML logowania SSO',
  ssoSniForSsoMetadataRetrieval: 'Użyj SNI do pobierania metadanych SSO',
  standard: 'Standardowe',
  standardUserGroup: 'Standardowa grupa użytkowników',
  startDate: 'Data Rozpoczęcia',
  startDateRequired: 'Wymagana data rozpoczęcia.',
  state: 'Stan',
  'static': 'Statyczne',
  status: 'Status',
  statusCode: 'Kod Statusu | Kody Statusu',
  stitchPages: 'Połącz Strony',
  storeFilterValues: 'Zapisz wartości filtra',
  storeFilterValuesDescription: 'Włączenie tego ustawienia spowoduje zapisanie wartości określonych przez użytkowników w filtrach strony wyszukiwania dla tego tagu.',
  storeFrontAdmin: 'Administrator Storefront',
  storefront: 'Storefront',
  storefrontIntegration: 'Integracja ze Storefront | Integracje ze Storefront',
  storefrontIntegrationSubtitle: 'Te ustawienia dotyczą różnych elementów integracji ze Storefront. Zachowaj szczególną ostrożność przy wprowadzaniu zmian. Skontaktuj się z Pomocą Techniczną Documoto w celu uzyskania dodatkowych informacji.',
  storefrontSettings: 'Ustawienia Storefront',
  storefrontSettingsDescription: 'Te ustawienia dotyczą różnych elementów i opcji ze Storefront. Zachowaj szczególną ostrożność przy wprowadzaniu zmian. Skontaktuj się z Documoto Services w celu uzyskania dodatkowych informacji.',
  storefrontSettingsOrgDescription: 'Te ustawienia dotyczą różnych elementów i opcji na poziomie organizacji Storefront. Zachowaj szczególną ostrożność przy wprowadzaniu zmian. Skontaktuj się z Documoto Services w celu uzyskania dodatkowych informacji.',
  stroke: 'Pociągnięcie',
  style: 'Styl | Style',
  styles: {
    colorHotpoint: 'Domyślne ustawienie hotpoint',
    inheritedFromOrg: 'Przejęto od organizacji {org}',
    inheritedFromSystem: 'Przejęto od domyślnych ustawień systemu',
    inheritedFromTenant: 'Przejęto od najemcy',
    invalidHexcode: 'Błędny kod hex',
    organization: 'Styl organizacji | Style organizacji',
    organizationSaved: 'Zapisano style organizacji',
    sampleNavigation: 'Karty nawigacji',
    samplePrimary: 'Nawigacja/przyciski',
    sampleSelectedHotpoint: 'Wybrane hotpointy',
    tenant: 'Styl najemcy | Style najemcy',
    tenantSaved: 'Zapisano style najemcy'
  },
  subChapter: 'Podrozdział | Podrozdziały',
  subject: 'Temat',
  subjectMessage: 'Wymagany jest temat',
  submit: 'Prześlij',
  submitPurchaseOrder: 'Zamówienie Zakupu',
  submitRequestForQuote: 'Zapytanie Ofertowe',
  submitted: 'Przesłane',
  submittedBy: 'Przesłane przez',
  submittedFilesMessage: 'Przesłano pliki ({fileCount}).',
  submitter: 'Nadawca',
  submitterEmail: 'Adres e-mail przesyłającego',
  submitterFirstName: 'Imię przesyłającego',
  submitterLastName: 'Nazwisko przesyłającego',
  submitterOrgName: 'Nazwa organizacji przesyłającego',
  submitterUserName: 'Nazwa użytkownika przesyłającego',
  success: 'Sukces',
  successNotificationDuration: 'Dodaj do Koszyka – Czas trwania Powiadomienia Toast o Sukcesie',
  suffix: 'Sufiks | Sufiksy',
  suggestedKeywords: 'Sugerowane słowa kluczowe',
  suggestedResults: 'Sugerowane wyniki',
  suggestion: 'Sugestia | Sugestie',
  sun: 'Nd',
  superAdminSettings: 'Ustawienia superadministratora',
  superadmin: 'Superadministrator',
  supersede: 'Zastąp',
  supersedeComplete: 'Czy na pewno chcesz zakończyć sesję nadrzędną?',
  supersedeDiscardChanges: 'Czy zakończyć sesję nadrzędną?',
  supersedeMainText: 'Sesja nadrzędna zastępuje istniejącą część co najmniej jedną nową częścią na każdej stronie, na której znajduje się stara część. Stary numer części jest usuwany, ale można go używać do wyszukiwania przez znaczniki, a zatem możliwe jest wyszukanie zawartości przy użyciu starego(-ych) lub nowego(-ych) numeru(-ów).',
  supersedeMessage: 'Aktualizacje dotyczące części wchodzą w życie natychmiast. Wyszukiwanie będzie odzwierciedlać aktualizacje w ciągu kilku minut.',
  supersedeNotProcessed: 'Sesja nadrzędna nie będzie przetwarzana.',
  supersedeReplacePart: 'Znajdź jedną lub więcej części, które zastąpią wybraną część',
  supersedeSuccessful: 'Zastępowanie Zakończone Powodzeniem',
  supersedeWith: 'Zastąp Część…',
  superseded: 'Zastąpione',
  supersededParts: 'Zastąpione części',
  supplier: 'Dostawca | Dostawcy',
  supplierDescription: 'Firma dostarczająca część',
  supplierKey: 'Klucz dostawcy',
  supportedDraftArchives: 'Nieobsługiwany format pliku; obsługiwane formaty wersji roboczej: MDZ, PLZ',
  supportedImageFormats: 'Obsługiwane formaty obrazów: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Ujmij wyszukiwane frazy w cudzysłowach, aby uzyskać dokładny wynik.',
  svgFinder: 'Wyszukiwarka SVG',
  swedishDescription: 'Opis Szwedzki',
  swedishName: 'Nazwa Szwedzka',
  system: 'System',
  systemAdmin: 'Administrator Systemu',
  systemFieldSearchAndFiltering: 'Wyszukiwanie i filtrowanie w polach systemowych',
  systemFields: 'Pola Systemowe',
  systemName: 'Nazwa systemu',
  systemStatus: 'Stan Systemu',
  systemVersion: 'Wersja systemu',
  tabDelimited: 'Tekst rozdzielany tabulatorami',
  tableOfContents: 'Spis Treści',
  tabloid: 'Tabloid',
  tag: 'Znacznik | Znaczniki',
  tagDeleteAffectedCount: 'Spowoduje to usunięcie znacznika oraz informacji o znaczniku z {count} elementów.',
  tagDeleteAffectedNone: 'Żaden element nie używa obecnie tego znacznika.',
  tagEditor: {
    filterPrompt: 'Wyświetlono pierwszych 100 wartości. Użyj filtra, aby wyświetlić więcej.',
    rangeBoundLengthInvalid: 'Granica nie może mieć więcej niż {limit} cyfr.',
    tagEditorModal: 'Modalny Edytor Znaczników',
    textfieldHelpText: 'Wpisz jedną lub kilka wartości oddzielonych średnikiem. Przykład: SN001; SN002'
  },
  tagManagerDeleteWarning: 'Wszelkie istniejące multimedia z {deleteCategoryName} zostaną wyłączone z tej kategorii po jej usunięciu.',
  tagName: 'Nazwa tagu',
  tagSearchAndFiltering: 'Wyszukiwanie i filtrowanie wg tagów',
  tagSearchAndFilteringHelpText: 'Wskazówka: niektóre ustawienia wyszukiwania i filtrowania można również skonfigurować w edytorach Menedżera tagów dostępnych tutaj: ',
  tagSubmitAffected: 'Poza wprowadzeniem zmian, znacznik {tag} zostanie odłączony od wszystkich treści typu {type}.',
  tagValue: 'Wartość tagu | Wartości Tagu',
  tagValueMissing: 'Musisz wprowadzić wartość tagu',
  tagValueMultiple: 'Wiele wpisów rozdzielonych średnikami',
  tagValueTooLong: 'Wartość znacznika przekracza limit 25 znaków | Wartości znacznika przekraczają limit 25 znaków',
  tagsDeleteError: 'Nie udało się usunąć co najmniej jednego tagu',
  tagsDeleteSuccess: 'Usunięto tagi',
  tagsDisplayMore: 'Wyświetlono pierwszych 100 wartości. Użyj filtra, aby wyświetlić więcej.',
  tagsManager: 'Menedżer Zadań',
  tagsSaveError: 'Nie udało się zapisać co najmniej jednego tagu',
  tagsSaveSuccess: 'Zapisano tagi',
  tagsUpdateError: 'Nie udało się zaktualizować co najmniej jednego tagu',
  tagsUpdateSuccess: 'Zaktualizowano tagi',
  targetBrowseFlow: 'Docelowy kierunek przeglądania',
  taxon: 'Takson',
  taxonomy: 'Taksonomia',
  template: 'Szablon | Szablony',
  templateEmailRecipients: 'Szablon Odbiorców Wiadomości E-mail',
  templateLayout: {
    addItem: 'Dodaj element',
    addRow: 'Dodaj wiersz',
    deleteColumn: 'Usuń kolumnę',
    deleteRow: 'Usuń wiersz',
    fullWidth: 'Pełna szerokość',
    oneColumn: 'Jedna kolumna',
    threeColumns: 'Trzy kolumny',
    twoColumns: 'Dwie kolumny'
  },
  tenant: 'Dzierżawca | Dzierżawcy',
  tenantAdmin: 'Administracja Dzierżawcami',
  tenantAdminMessage: 'Kontroluje ustawienia dzierżawców',
  tenantCleanerJob: 'Utrzymanie Dzierżawy',
  tenantConfiguration: 'Konfiguracja dzierżawcy',
  tenantEmailRecipients: 'Odbiorcy Wiadomości E-mail do Dzierżawców',
  tenantEmailRecipientsOverrideMessage: 'Zostaną nadpisane, jeśli Odbiorcy Wiadomości E-mail dla Organizacji są wskazani',
  tenantIndexQueueJob: 'Kolejka Indeksu Dzierżawy',
  tenantKey: 'Klucz dzierżawcy',
  tenantKeyError: 'Klucz dzierżawcy nie jest unikatowy',
  tenantKeyMessage: 'Klucz dzierżawcy musi być unikatowy',
  tenantLabelDeleteMessage: 'Usunięcie etykiety spowoduje przywrócenie domyślnej nazwy Documoto.',
  tenantLabelsPageText: 'Etykiety są używane do dostosowywania nazw wielu obiektów znajdujących się w Bibliotece i na Ekranach Administracyjnych Documoto.',
  tenantPrintSettingsDescription: 'Wybierz domyślne ustawienia drukowania, dla całej dzierżawy. Te ustawienia będą używane dla wszystkich wydruków katalogów, chyba że zostaną zmienione w sekcjach Organizacja lub Multimedia. ',
  tenantReindexModulus: 'Moduł reindeksowania dzierżawcy',
  tenantSettings: {
    collapseTOCLabel: 'Zwiń Spis Treści na Pasującej Stronie',
    defaultLocaleLabel: 'Domyślna Lokalizacja',
    defaultLocaleMessage: 'Domyślna lokalizacja dzierżawcy.',
    defaultSupplierLabel: 'Dostawca Domyślny',
    defaultSupplierMessage: 'Domyślny dostawca dzierżawcy.',
    deleteMissingTranslationsOnPublishLabel: 'Usunąć brakujące tłumaczenia podczas publikowania?',
    deleteMissingTranslationsOnPublishMessage: 'Włącz usuwanie brakujących tłumaczeń podczas publikowania',
    enableChapterIndexingLabel: 'Włącza opcję indeksowania dla rozdziałów mediów',
    enableChapterIndexingMessage: 'Zaindeksuj rozdziały',
    enableIndexingLabel: 'Indeks w zakresie Publikowania',
    enableIndexingMessage: 'Włącza indeksowanie dla publikowania.',
    excludePartsFromAccessControlChecksLabel: 'Wyklucz części z reguł kontroli dostępu',
    excludePartsFromAccessControlChecksMessage: 'Gdy ta opcja jest włączona, części są widoczne dla wszystkich użytkowników, niezależnie od kontroli dostępu do multimediów.',
    exportPgAsHashLabel: 'Eksportuj nazwę pliku strony jako klucz skrótu',
    exportPgAsHashMessage: 'Użyj kluczy skrótu strony jako nazw plików strony w eksportowanej zawartości',
    helpUrlLabel: 'Domyślny Adres URL Pomocy',
    helpUrlMessage: 'Adres URL alternatywnego systemu pomocy.',
    hotPointLinkPageInBookOnlyLabel: 'Tylko Linki Hotpoint do Strony w Sprawozdaniu',
    hotPointLinkPageInBookOnlyMessage: 'Tylko Linki Hotpoint ze Stron w Sprawozdaniu',
    lockPartTrOnPublishLabel: 'Zablokuj brakujące tłumaczenia podczas publikowania',
    lockPartTrOnPublishMessage: 'Uniemożliwia modyfikowanie brakujących tłumaczeń podczas publikowania',
    mediaTimestampLabel: 'Aktualizuj Znacznik Czasu Multimediów przy Zmianie Ustawień Kontroli Dostępu',
    mediaTimestampMessage: 'Włącz, jeśli zmiana kategorii multimediów kontroli dostępu powinna powodować aktualizację znacznika czasu multimediów.',
    publisherDefaultUom: 'Domyślna JM Publikującego',
    publishingContactLabel: 'Adres E-mail Kontaktu Publikującego',
    publishingContactMessage: 'Domyślny adres e-mail, na który przesyłane będą wiadomości, gdy zostanie zgłoszony problem z treścią.',
    replaceHotpointLabel: 'Zawsze Zastępuj Łącza Hotpoint przy Publikacji',
    replaceHotpointMessage: 'Tylko w przypadku publikacji w Docustudio.',
    ssoLoginSystemLabel: 'System logowania SSO',
    ssoLoginSystemMessage: 'Dostawca tożsamości dla SSO.',
    userPasswordExpirationLabel: 'Dni do wygaśnięcia hasła użytkownika',
    userPasswordExpirationMessage: 'Liczba dni, po których należy zresetować hasła; pozostaw puste, aby nigdy nie wygasło'
  },
  tenantSettingsSaved: 'Zapisano Ustawienia Najemcy',
  tenantSettingsSubtitle: 'Te ustawienia sterują wszystkimi właściwościami i zachowaniami najemcy. Przy wprowadzaniu zmian należy zachować ostrożność. W celu uzyskania dalszych informacji należy Skontaktować się z Działem usług Documoto.',
  tenantSettingsTitle: 'Ustawienia Najemcy',
  tenantSuppliers: 'Dostawcy dzierżawcy',
  tenantType: 'Typ dzierżawcy',
  tenantWebserviceUser: 'Użytkownik usługi internetowej dzierżawcy',
  text: 'Tekst',
  textArea: 'Obszar Tekstowy',
  textColor: 'Kolor tekstu',
  textField: 'Pole Tekstowe',
  textFile: 'Plik Tekstowy (CSV, TXT)',
  textTool: 'Narzędzie Tekstowe',
  threeD: {
    addFile: 'Dodaj plik z częściami 3D',
    beforeSaveModal: {
      message: 'Czy chcesz zastąpić ten plik w każdej lokalizacji, czy tylko dołączyć go do tej części? Jeśli zdecydujesz się zastąpić plik:',
      messageBulletOne: '{count} Nastąpi aktualizacja części nowym plikiem CAD',
      messageBulletOneForContent: 'Nastąpi aktualizacja {count} {contentType} z wykorzystaniem nowego pliku CAD',
      messageBulletTwo: 'Poprzednia wersja pliku zostanie usunięta z systemu plików Documoto',
      tip: 'Wskazówka: Aby zapobiec nadpisaniu pliku podczas procesu dołączania, przed zaimportowaniem możesz zmienić jego nazwę.',
      title: 'W systemie Documoto już istnieje plik CAD o tej nazwie.'
    },
    deleteTitle: 'Czy na pewno chcesz usunąć widok 3D?',
    drawMode: {
      hiddenLines: 'Ukryte linie',
      label: 'Tryb rysowania',
      shaded: 'Zacienienie',
      wireframe: 'Szkielet',
      wireframeShaded: 'Szkielet z zacienieniem'
    },
    explode: 'Rozbij na części',
    failureCreatingBomAssociations: 'Niepowodzenie podczas tworzenia skojarzeń BOM modelu 3D.',
    fileSizeModal: {
      message: 'Maksymalny rozmiar pliku dozwolony w Documoto wynosi 25 megabajtów. Plik, który chcesz załadować, przekracza tę wartość i nie można go załadować. Kliknij „OK”, aby kontynuować.',
      title: 'Przekroczono maksymalny rozmiar pliku'
    },
    fileSizeModalWarning: {
      message: 'Maksymalny rozmiar samodzielnego pliku dozwolony w Documoto to {size} MB. Jeden z plików, które chcesz przesłać, przekracza tę wartość i nie może zostać przesłany. Kliknij „OK”, aby kontynuować.',
      title: 'Przekroczono maksymalny rozmiar pliku'
    },
    freeTierCurrentCount: 'Masz {count} z 15 aktywnych modeli 3D darmowego poziomu. Po osiągnięciu limitu nie będzie można publikować nowych stron z modelami 3D. Skontaktuj się z opiekunem klienta, aby zaktualizować subskrypcję.',
    freeTierExceededError: 'Publikowanie tej strony z modelem 3D jest niedozwolone.',
    freeTierExceededOption1: 'Skontaktuj się z opiekunem klienta, aby zaktualizować subskrypcję.',
    freeTierExceededOption2: 'Usuń model 3D z wersji roboczej strony, aby ją opublikować.',
    freeTierExceededTitle: 'Przekroczono limit 15 aktywnych modeli 3D',
    illustrationLabel: 'Widok 2D',
    invalidFile: 'Przesłano niepoprawny plik',
    mapModelToBom: 'Mapowanie modelu do BOM',
    modelLabel: 'Model 3D',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: 'Nie można znaleźć części BOM pasujących do numerów części modelu 3D',
    noPartsMatchRegEx: 'Żadne części BOM nie pasują do wyrażenia regularnego',
    orientation: 'Orientacja',
    orientationAndProjection: {
      back: 'Tył',
      bottom: 'Dół',
      front: 'Przód',
      isometric: 'Izometryczny',
      left: 'Lewy',
      orthographic: 'Ortograficzny',
      perspective: 'Perspektywa',
      projection: 'Odwzorowanie',
      right: 'Prawy',
      top: 'Góra'
    },
    partNumberProperty: 'Właściwość numeru części',
    partNumberRegex: 'Wyrażenie regularne numeru części',
    partNumbersInModel: 'Numery części w modelu',
    resetCamera: 'Resetuj aparat',
    setAsDefaultView: 'Ustaw jako widok domyślny',
    setAsDefaultViewTooltip: 'Ustaw tę orientację i poziom przybliżenia jako domyślny widok początkowy.',
    slice: {
      label: 'Wycinek',
      planeX: 'Płaszczyzna cięcia X',
      planeY: 'Płaszczyzna cięcia Y',
      planeZ: 'Płaszczyzna cięcia Z',
      reset: 'Resetuj płaszczyznę cięcia',
      section: 'Przełącz przekrój płaszczyzny cięcia',
      visibility: 'Przełącz widok płaszczyzny cięcia'
    },
    successfullyCreatedBomAssociations: 'Utworzono skojarzenia BOM modelu 3D {count}',
    successfullySavedDefaultView: 'Zapisano widok domyślny',
    supportedFilesMessage: 'System Documoto obsługuje różne formaty plików CAD. Skontaktuj się z centrum pomocy, jeśli nie masz pewności, czy dany format pliku CAD jest obsługiwany.',
    threeD: '3D',
    toolsLabel: 'Narzędzia 3D',
    topAssemblyFilename: 'Nazwa pliku Top Assembly',
    topAssemblyFilenameInvalid: 'Plik zespołu najwyższego poziomu nie znajduje się na liście plików',
    topAssemblyFilenameRequired: 'Nazwa pliku Top Assembly jest wymagana',
    viewerControls: 'Elementy sterujące przeglądarki',
    viewerSettings: 'Ustawienia przeglądarki 3D',
    viewerTitle: 'Podgląd 3D'
  },
  thu: 'Cz',
  thumbnail: 'Miniatura',
  thumbnailDeleted: 'Pomyślnie Usunięto Miniatury',
  thumbnailDeletedError: 'Usunięcie Miniatury Nie Powiodło Się',
  thumbnailReapplyWarning: 'System może ponownie zastosować miniaturę na podstawie zawartości multimediów. To może zająć kilka minut.',
  thumbnailResizeTooltip: 'Po zaznaczeniu umożliwia zmianę rozmiaru miniatur do maksymalnego rozmiaru 500 × 500 pikseli.',
  thumbnailUpdated: 'Pomyślnie Zaktualizowano Miniatury',
  thumbnailUpdatedError: 'Aktualizacja Miniatury Nie Powiodła Się',
  title: 'Tytuł',
  to: 'Do',
  toDate: 'Do Dnia',
  toGetStarted: 'aby rozpocząć.',
  toastNotifications: 'Powiadomienia Toast',
  toc: 'Spis Treści',
  tocClipBoardSuccessTitle: 'Skopiowano do Schowka',
  tocClipBoardWarningText: 'OSTRZEŻENIE: Niezapisane zmiany nie mogą zostać skopiowane do schowka',
  tocClipBoardWarningTitle: 'Skopiowano do Schowka',
  tocDisplayingFirstValues: 'Wyświetlono pierwszych 100 wartości. Użyj filtra, aby wyświetlić więcej.',
  tocDuplicateWarningText: 'W rozdziale wykryto powieloną stronę. Duplikat został usunięty.',
  tocEmptyMessage: 'Wygląda na to, że nie utworzono jeszcze Spisu Treści.',
  tocMissingChapterName: 'Brak Tytułu Rozdziału',
  tocModalTableCaption: 'Modalny Edytor Znaczników',
  tocNothingSelected: 'Niczego Nie Wybrano',
  tocOpenEditor: 'Otwórz Edytor',
  tocSaveRequired: 'Wymagane jest zapisanie przed przystąpieniem do edycji szczegółów rozdziału',
  tocState: 'Początkowy Stan Spisu Treści',
  tocThumbnailDeleteFailTitle: 'Usunięcie Miniatury Nie Powiodło Się',
  tocThumbnailDeleteSuccessTitle: 'Pomyślne Usunięcie Miniatury',
  tocThumbnailUploadFailTitle: 'Przekazanie Miniatury Nie Powiodło Się',
  tocThumbnailUploadSuccessTitle: 'Pomyślne Przekazanie Miniatury',
  tocTranslationMessage: 'Nazwa i opcjonalny opis tego rozdziału',
  tocUntitledPage: 'Strona Bez Tytułu',
  togglePage: 'Przełącz Stronę',
  tooManySelections: 'Lista przekracza limit wyboru wynoszący {limit}',
  top: 'Na Górze',
  total: 'Łącznie',
  totalItems: 'Pozycje Łącznie',
  translation: 'Tłumaczenie | Tłumaczenia',
  translationHelpTextItem: 'Nazwa i opcjonalny opis elementu {item}',
  'true': 'Prawda',
  tryAgain: 'Spróbuj ponownie.',
  trySearchingToc: 'Spróbuj wyszukać dowolne słowo, jakie widzisz lub pamiętasz – to natychmiast zawęzi listę wyników. Widok się nie zmieni, dopóki nie klikniesz wyniku.',
  tryThis: 'Spróbuj tego',
  tue: 'Wt',
  turkishDescription: 'Opis Turecki',
  turkishName: 'Nazwa Turecka',
  twoSided: '2-stronnie',
  type: 'Typ | Typy',
  typeAtLeastTwoChars: 'Wpisz co najmniej 2 znaki, aby zobaczyć listę dopasowań.',
  typeSearchCriteriaAlreadySet: 'Usuń wybrane kryteria wyszukiwania „Typ”, aby zastosować zmiany.',
  typeToConfirm: 'Typ do potwierdzenia: {value}',
  typography: 'Typografia',
  ukraineDescription: 'Opis Ukraiński',
  ukraineName: 'Nazwa Ukraińska',
  unableToRetrieveResults: 'Nie można pobrać wyników zapytania/wyszukiwania',
  unauthorized: 'Niezatwierdzone',
  unknownError: 'Wystąpił nieznany błąd. W celu uzyskania pomocy skontaktuj się z pomocą techniczną Documoto pod adresem support{\'@\'}documoto.com',
  unknownInput: 'Nieznany typ danych wejściowych:',
  unknownPart: 'Nieznana Część',
  unknownType: 'Nieznany typ',
  unsavedAPIKeyWarning: 'Twój Klucz API zostanie utracony, jeśli nie Wrócisz',
  unsavedChanges: 'Masz niezapisane zmiany. Kontynuować?',
  unsavedChangesWarning: 'Zmiany zostaną utracone, jeżeli ich nie zapiszesz.',
  unsavedWidgetKeyWarning: 'Jeśli nie wrócisz, utracisz klucz widżetu.',
  unsupportedBrowserMessage: 'Stworzyliśmy tę aplikację przy użyciu najnowszych technologii. Sprawia to, że jest ona szybsza i łatwiejsza w obsłudze. Niestety Twoja przeglądarka nie obsługuje tych technologii.',
  untitledOrg: 'Organizacja Bez Tytułu',
  unverified: 'Nie zweryfikowano',
  uom: 'Jednostka Miary',
  update: 'Aktualizuj',
  updateFailed: 'Aktualizacja nie powiodła się',
  updateIndex: 'Aktualizuj Indeks',
  updatePassword: 'Aktualizuj Hasło',
  updatePasswordMessage: 'Pomyślnie zaktualizowano hasło',
  updatePasswordPending: 'Trwa zapisywanie zmiany hasła.',
  updated: 'Zaktualizowano',
  upgradeBrowser: 'Zaktualizuj przeglądarkę.',
  upload: 'Prześlij',
  uploadComplete: 'Ukończono Przekazywanie',
  uploadFileSizeLimitExceeded: 'Przekroczono limit rozmiaru pliku do wyświetlenia w aplikacji.',
  uploadInProgress: 'Przekazywanie w Toku',
  uponSavingDisabledTenant: 'Po zapisaniu tej strony przy tym ustawieniu:',
  uponSavingThisLicense: 'NALEŻY WYKONAĆ NASTĘPUJĄCE CZYNNOŚCI:',
  upperBound: 'Górne Ograniczenie',
  usCurrency: 'USD',
  useDefaultCartColumns: 'Użyj Domyślnych Kolumn Koszyka',
  useDefaultPartsListColumns: 'Użyj Domyślnego Układu Listy Części',
  useSequentialPageNumbering: 'Stosuj Ciągłe Numerowanie Stron',
  useSniForSsoMetadataRetrieval: 'Użyj SNI do pobierania metadanych SSO',
  user: 'Użytkownik',
  userAddress: 'Adresy Użytkownika | Adresy Użytkowników',
  userCount: 'Liczba Użytkowników',
  userEditable: 'Edytowalne przez Użytkownika',
  userExpirationDate: 'Data wygaśnięcia dla użytkownika',
  userExpirationDateInvalid: 'Należy podać datę wygaśnięcia dla użytkownika',
  userGroup: 'Grupa Użytkowników | Grupy Użytkowników',
  userGroupEmpty: 'Grupy Użytkowników nie mogą być puste',
  userGroupType: 'Typ grupy użytkowników',
  userGroupUniqueMessage: 'Ta nazwa musi być unikalna w stosunku do pozostałych nazw Grup Użytkowników dla tego dzierżawcy',
  userGroupUsers: 'Użytkownicy w Grupie',
  userSettings: 'Ustawienia użytkownika',
  userVerificationEmailBody: 'Treść wiadomości e-mail weryfikującej użytkownika',
  userVerificationEmailFieldsValidation: 'Oba pola wiadomości e-mail weryfikującej użytkownika muszą być niepuste lub puste',
  userVerificationEmailSubject: 'Temat wiadomości e-mail weryfikującej użytkownika',
  username: 'Nazwa Użytkownika',
  usernameEmpty: 'Pole Nazwy Użytkownika nie może być puste',
  users: 'Użytkownicy',
  usersWillReceiveAnUnauthorizedError: 'przy próbie zalogowania do tego konta użytkownicy zobaczą błąd „Brak uprawnień”.',
  validate: 'Potwierdź',
  validateTenantDirectories: {
    buttonLabel: 'Weryfikuj katalogi zawartości',
    error: 'Nie udało się zweryfikować katalogów',
    success: 'Zweryfikowane katalogi dzierżawców'
  },
  validationMessage: 'Komunikat Walidacji | Komunikaty Walidacji',
  value: 'Wartość',
  valueGteError: 'Wartość musi być niższa od lub równa {max}',
  valueLteError: 'Wartość musi być wyższa od lub równa {min}',
  variantSKU: 'SKU Wariantu',
  vendorName: 'Nazwa dostawcy',
  verificationEmailRequested: 'Weryfikacyjna wiadomość e-mail zostanie wysłana po zapisaniu.',
  verificationEmailSent: 'Wysłano weryfikacyjną wiadomość e-mail.  Nie ustawiono hasła.',
  verified: 'Zweryfikowano',
  verifyPassword: 'Potwierdź Hasło',
  verifying: 'Weryfikacja',
  version: 'Wersja',
  vertical: 'Pionowo',
  video: 'Film | Filmy',
  view: 'Widok',
  viewAll: 'Zobacz wszystko',
  viewAllPagesAndBooks: 'Widok: Wszystkie strony i księgi',
  viewAllResults: 'Zobacz wszystkie wyniki',
  viewBooks: 'Widok: Księgi',
  viewModeList: 'Widok Listy',
  viewModeTable: 'Widok Tabeli',
  viewMore: 'Zobacz więcej',
  viewPages: 'Widok: Strony',
  viewWhereUsed: 'Zobacz informacje o miejscu używania',
  views: 'Widoki',
  visibility: 'Widoczność',
  visibilityDescription: 'Kto może przeglądać treści: {entity}',
  visible: 'Widoczne',
  waitForUpload: 'Zaczekaj na zakończenie przekazywania.',
  watermark: 'Znak wodny',
  watermarkFont: 'Czcionka znaku wodnego',
  watermarkOpacityPercentage: 'Widoczność znaku wodnego (%)',
  watermarkOrientation: 'Kierunek znaku wodnego',
  watermarkSaveFailed: 'Nie udało się zapisać znaku wodnego.',
  watermarkSaved: 'Zapisano znak wodny',
  watermarkSelectionRequired: 'Wymagana nazwa użytkownika lub tekst.',
  watermarkText: 'Tekst znaku wodnego',
  wed: 'Śr',
  whereUsed: 'Miejsca Użycia',
  whereUsedCountInSearchBar: 'Licznik miejsc używania w pasku wyszukiwania',
  whoCanViewComment: 'Kto może zobaczyć ten komentarz?',
  wholesale: 'Hurtowa',
  wholesalePrice: 'Cena Hurtowa',
  wholesaleTotal: 'Łączna Cena Hurtowa',
  widget: 'Widżet',
  widgetAuthHeader: 'Wartość autoryzacji widżetu',
  widgetErrorConfig: 'Nie można uruchomić widżetu z powodu jego nieprawidłowej konfiguracji',
  widgetErrorInit: 'Nie można uruchomić widżetu Documoto',
  widgetErrorLocation: 'Nie udało się zlokalizować wskazanej treści w widżecie',
  widgetErrorMultipleLocations: 'Znaleziono wiele lokalizacji dla wskazanej treści',
  widgetKey: 'Klucz widżetu | Klucze widżetów',
  widgetKeyAdmin: 'Administrator klucza widżetu',
  widgetKeyCopied: 'Wartość autoryzacji widżetu skopiowana do schowka',
  widgetKeyDeleteMsg: 'Usunięcie klucza widżetu uniemożliwi jego wykorzystanie',
  widgetKeyDeleted: 'Usunięto klucz widżetu',
  widgetKeyDeletedError: 'Podczas usuwania klucza widżetu wystąpił błąd',
  widgetKeyManager: 'Menedżer kluczy widżetów',
  widgetKeyNameEmpty: 'Nazwa musi być unikatowa i jest wymagana. Wartość ta zostanie również wykorzystana do celów raportowania i logowania jako nazwa użytkownika dla dowolnej aktywności widżetu',
  widgetKeyRegenError: 'Podczas ponownego generowania klucza widżetu wystąpił błąd',
  widgetKeyRegenMsg: 'Ponowne wygenerowanie tego klucza widżetu może dezaktywować istniejące integracje',
  widgetKeyRegenTitle: 'Czy na pewno chcesz ponownie wygenerować ten klucz widżetu?',
  widgetKeySaved: 'Zapisano klucz widżetu',
  widgetPermissions: 'Użytkowników widżetu można tylko odczytać, a dostępem do funkcji zarządza się na poziomie konfiguracji widżetu. Standardowe uprawnienia dla grupy użytkowników nie mają zastosowania do użytkowników widżetu. Zastosowania mają natomiast uprawnienia dostępu do kategorii multimediów. Przejdź do opcji przypisania kontroli dostępu do kategorii multimediów.',
  widgetRefreshErrorMsg: 'Odśwież stronę, aby wyświetlić żądane treści',
  widgetUserGroup: 'Grupa użytkowników widżetu',
  widgetUserGroupDeleteMsg: 'Nie można usunąć grupy widżetu z użytkownikami',
  willBeAffected: 'będzie dotyczyć.',
  willBeDeleted: 'Treść {content} zostanie usunięta.',
  willBeInsertedIntoItem: 'Nazwa {name} zostanie wstawiona do pozycji {item}',
  willBeUpdated: 'zostanie zaktualizowane(-a/-y).',
  year: 'Rok',
  yourEmailAddress: 'Twój adres e-mail',
  zipCode: 'Kod Pocztowy',
  zoomHotpointToCanvas: 'Zbliż i Dostosuj Łącze Hotpoint do rozmiaru Tła',
  zoomIn: 'Powiększ',
  zoomOut: 'Pomniejsz'
};
/* eslint-enable max-len */
